<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12" v-if="section !== 'stock'">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                        <h4 class="mb-3">{{ pageTitle }} <b-spinner v-if="showspinner" small variant="primary" class="align-middle"></b-spinner></h4>
                        <p class="mb-0">管理所有货主的海外仓库库存并处理出库请求<small class="d-block">(전체 화주의 해외창고 재고를 관리하고 출고요청을 처리합니다)</small></p>
                    </div>
                </div>
            </div>
            <!-- 조회 중 표시는 제목 옆 / 재고현황 빈 칸의 작은 스피너로만 한다. 화주 필터·「刷新」 버튼이 빠진 뒤 그 카드가
                 「불러오는 동안만」 남아 있어서, 처음 열면 빈 박스가 3초쯤 떴다가 사라졌다(2026-10-07 YZY) -->
            <!-- 「海外仓库：…」 상태 집계 줄은 出库列表 에서 뺐다(2026-10-07 YZY) — 库存列表(section="stock") 에서만 보인다 -->
            <div class="col-lg-12" v-if="allStatusData.length > 0 && section !== 'outbound'">
                <b-card class="mb-3">
                    <div class="d-flex flex-wrap align-items-center gap-2">
                        <span class="font-weight-bold mr-2">🏭 海外仓库<small>(해외창고)</small>:</span>
                        <span class="badge badge-light border px-2 py-1">配送完成<small>(배송완료)</small> <b class="text-info">{{ sc.배송완료 }}</b></span>
                        <span class="badge badge-light border px-2 py-1">入库作业<small>(입고작업)</small> <b class="text-warning">{{ sc.입고작업 }}</b></span>
                        <span class="badge badge-warning border px-2 py-1">📦出库请求<small>(출고요청)</small> <b class="text-dark">{{ sc.출고요청 }}</b></span>
                        <span class="badge badge-light border px-2 py-1">出库待发<small>(출고대기)</small> <b class="text-primary">{{ sc.출고대기 }}</b></span>
                        <span class="badge badge-light border px-2 py-1">中国库存<small>(중국재고)</small> <b class="text-dark">{{ sc.중국재고 }}</b></span>
                        <span class="mr-3"></span>
                        <span class="font-weight-bold mr-2">🚢 运输中<small>(이동중)</small>:</span>
                        <span class="badge badge-light border px-2 py-1">出库完成<small>(출고완료)</small> <b class="text-success">{{ sc.출고완료 }}</b></span>
                        <span class="badge badge-light border px-2 py-1">海外入库中<small>(해외입고중)</small> <b class="text-info">{{ sc.해외입고중 }}</b></span>
                        <span class="badge badge-light border px-2 py-1">国内入库中<small>(국내입고중)</small> <b class="text-primary">{{ sc.국내입고중 }}</b></span>
                    </div>
                </b-card>
            </div>
            <div class="col-lg-12">
                <b-card>
                    <!-- 库存列表 에 끼울 때는 탭 줄을 바깥(库存列表 한 줄 탭)이 그린다 — tab prop 으로 보일 탭만 받는다(2026-10 YZY) -->
                    <b-tabs v-model="activeTab" content-class="mt-3" :nav-wrapper-class="tab !== null ? 'd-none' : ''">
                        <!-- 出库请求处理(출고요청 처리) 탭은 사이드바 货主库存出库 메뉴(ShipmentRequestList)로 옮겼다(2026-10 YZY) -->
                        <b-tab v-if="showSection('stock')" title="📋 库存现况(재고현황)">
                            <div v-if="inventoryList.length===0" class="text-center text-muted py-5">
                                <p><b-spinner v-if="showspinner" small variant="primary" class="mr-1"></b-spinner>搜索后显示库存现况(검색 후 재고현황이 표시됩니다).</p>
                            </div>
                            <div v-else>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <span class="font-weight-bold">库存现况(재고현황) {{ filteredInventory.length }}件 / 全部(전체) {{ inventoryList.length }}件</span>
                                    <div class="d-flex align-items-center">
                                        <label class="mr-2 mb-0 small">状态筛选(상태필터):</label>
                                        <b-form-select v-model="inventoryStatusFilter" size="sm" style="width:160px">
                                            <option value="">全部(전체)</option>
                                            <option v-for="s in inventoryStatusOptions" :key="s" :value="s">{{ s }}</option>
                                        </b-form-select>
                                    </div>
                                </div>
                                <CDataTable :headers="inventoryHeaders" :items="filteredInventory"
                                            item-key="_id" storage-key="warehouseManagement.inventory">
                                    <template v-slot:processStatus="{ item }">
                                        <span :class="'badge badge-'+getStatusVariant(item.processStatus)">{{ item.processStatus }}</span>
                                    </template>
                                    <template v-slot:요청일="{ item }">{{ fmt(item.요청일) }}</template>
                                </CDataTable>
                            </div>
                        </b-tab>
                        <b-tab v-if="showSection('stock')" title="📊 出入库记录(입출고이력)">
                            <div class="d-flex align-items-center mb-3" style="gap: 8px;">
                                <b-form-input type="date" v-model="historyStartDate" size="sm" style="max-width: 160px;"></b-form-input>
                                <span>~</span>
                                <b-form-input type="date" v-model="historyEndDate" size="sm" style="max-width: 160px;"></b-form-input>
                                <b-button variant="primary" size="sm" @click="loadHistory">查询<small>(조회)</small></b-button>
                                <b-spinner small v-if="historyLoading" class="ml-2"></b-spinner>
                            </div>
                            <div v-if="historyList.length===0" class="text-center text-muted py-5">
                                <p>该期间无出入库记录(해당 기간 입출고이력이 없습니다).</p>
                            </div>
                            <div v-else>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <span class="font-weight-bold">出入库记录(입출고 이력) {{ historyList.length }}件<small v-if="historyList.length >= 1000" class="text-danger ml-2">最多1000件, 请缩小期间(최대 1000건 — 기간을 줄여 주세요)</small></span>
                                </div>
                                <CDataTable :headers="historyHeaders" :items="historyList"
                                            item-key="_k" storage-key="warehouseManagement.history">
                                    <template v-slot:changedAt="{ item }">{{ fmt(item.changedAt) }}</template>
                                    <template v-slot:fromStatus="{ item }">
                                        <span :class="'badge badge-'+getStatusVariant(item.fromStatus)">{{ item.fromStatus }}</span>
                                    </template>
                                    <template v-slot:toStatus="{ item }">
                                        <span :class="'badge badge-'+getStatusVariant(item.toStatus)">{{ item.toStatus }}</span>
                                    </template>
                                </CDataTable>
                            </div>
                        </b-tab>
                        <b-tab v-if="showSection('stock')" title="📥 手动入库(수동 입고)">
                            <b-card class="mb-3">
                                <h6 class="font-weight-bold mb-3">手动入库登记(수동 입고 등록)</h6>
                                <div class="row">
                                    <div class="col-md-3">
                                        <label class="small font-weight-bold">货主(화주)</label>
                                        <b-form-input type="text" list="manual-clist" v-model="manualInbound.companyid" size="sm" placeholder="选择货主(화주 선택)"></b-form-input>
                                        <datalist id="manual-clist"><option v-for="c in whCidOptions(manualInbound.companyid)" :key="c">{{ c }}</option></datalist>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="small font-weight-bold">商品名(상품명)</label>
                                        <b-form-input v-model="manualInbound.상품명" size="sm" placeholder="输入商品名(상품명 입력)"></b-form-input>
                                    </div>
                                    <div class="col-md-2">
                                        <label class="small font-weight-bold">条码(바코드)</label>
                                        <b-form-input v-model="manualInbound.바코드" size="sm" placeholder="条码(바코드)"></b-form-input>
                                    </div>
                                    <div class="col-md-2">
                                        <label class="small font-weight-bold">数量(수량)</label>
                                        <b-form-input v-model.number="manualInbound.수량" size="sm" type="number" min="1"></b-form-input>
                                    </div>
                                    <div class="col-md-2">
                                        <label class="small font-weight-bold">入库原因(입고사유)</label>
                                        <b-form-select v-model="manualInbound.사유" size="sm">
                                            <option value="직접입고">直接入库(직접입고)</option>
                                            <option value="반품입고">退货入库(반품입고)</option>
                                            <option value="이관입고">转移入库(이관입고)</option>
                                            <option value="기타">其他(기타)</option>
                                        </b-form-select>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <label class="small font-weight-bold">备注(메모)</label>
                                        <b-form-input v-model="manualInbound.메모" size="sm" placeholder="入库备注(입고 메모, 선택)"></b-form-input>
                                    </div>
                                    <div class="col-md-6 d-flex align-items-end">
                                        <b-button variant="success" size="sm" @click="submitManualInbound" :disabled="manualInboundProcessing">
                                            <b-spinner small v-if="manualInboundProcessing"></b-spinner>
                                            {{ manualInboundProcessing ? '处理中(처리중)...' : '📥 入库登记(입고 등록)' }}
                                        </b-button>
                                    </div>
                                </div>
                            </b-card>
                        </b-tab>
                        <b-tab v-if="showSection('outbound')" title="🏷️ 箱子/托盘标签(박스/파렛트 라벨)">
                            <div class="row">
                                <div class="col-md-6">
                                    <b-card class="mb-3">
                                        <h6 class="font-weight-bold mb-3">📦 箱子标签生成(박스 라벨 생성)</h6>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="small font-weight-bold">货主(화주)</label>
                                                <b-form-input list="label-clist" v-model="labelForm.companyid" size="sm" placeholder="选择货主(화주 선택)"></b-form-input>
                                                <datalist id="label-clist"><option v-for="c in whCidOptions(labelForm.companyid)" :key="'lc-'+c">{{ c }}</option></datalist>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="small font-weight-bold">负责人缩写(담당자 이니셜, 英文大写2字)</label>
                                                <b-form-input v-model="labelForm.담당자이니셜" size="sm" maxlength="2" placeholder="FK" @blur="saveInitials" style="text-transform:uppercase"></b-form-input>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-12 mb-2">
                                                <label class="small font-weight-bold d-block">出库形式(출고형태)</label>
                                                <!-- 테이프 색 = 버튼 색(표시만, 저장값 milkrun_box 등은 그대로) — utils/coupassStatusText -->
                                                <button v-for="t in boxTypeOptions" :key="'bt-'+t.value" type="button" class="btn btn-sm mr-1 mb-1 wh-outtype"
                                                        :style="outboundTypeStyle(t.value, labelForm.boxShipmentType !== t.value)"
                                                        @click="labelForm.boxShipmentType = t.value">{{ outboundTypeText(t.value) }} <small>{{ t.suffix }}</small></button>
                                            </div>
                                            <div class="col-md-4">
                                                <label class="small font-weight-bold">数量(수량)</label>
                                                <b-form-input v-model.number="labelForm.boxCount" type="number" size="sm" min="1" max="100"></b-form-input>
                                            </div>
                                            <div class="col-md-8 d-flex align-items-end">
                                                <b-button variant="primary" size="sm" block @click="generateBoxLabels" :disabled="labelLoading">📦 生成箱子(박스 생성)</b-button>
                                            </div>
                                        </div>
                                    </b-card>
                                </div>
                                <div class="col-md-6">
                                    <b-card class="mb-3">
                                        <h6 class="font-weight-bold mb-3">🔲 托盘标签生成(파렛트 라벨 생성)</h6>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="small font-weight-bold">清关方式(통관방식)</label>
                                                <b-form-select v-model="labelForm.customsType" size="sm">
                                                    <!-- 표시 라벨은 utils/coupassStatusText CUSTOMS_TYPE_TEXT 한 곳. 저장값(value)은 그대로 -->
                                                    <option value="integrated">{{ customsTypeText('integrated') }} (RUBY)</option>
                                                    <option value="kupass">{{ customsTypeText('kupass') }}</option>
                                                    <option value="client">{{ customsTypeText('client') }}</option>
                                                </b-form-select>
                                            </div>
                                            <div class="col-md-6" v-if="labelForm.customsType !== 'integrated'">
                                                <label class="small font-weight-bold">公司名(업체명)</label>
                                                <b-form-input list="label-pclist" v-model="labelForm.palletCompanyid" size="sm" placeholder="公司名(업체명)"></b-form-input>
                                                <datalist id="label-pclist"><option v-for="c in whCidOptions(labelForm.palletCompanyid)" :key="'lpc-'+c">{{ c }}</option></datalist>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-12 mb-2">
                                                <label class="small font-weight-bold d-block">出库形式(출고형태)</label>
                                                <button v-for="t in palletTypeOptions" :key="'pt-'+t.value" type="button" class="btn btn-sm mr-1 mb-1 wh-outtype"
                                                        :style="outboundTypeStyle(t.value, labelForm.palletShipmentType !== t.value)"
                                                        @click="labelForm.palletShipmentType = t.value">{{ outboundTypeText(t.value) }} <small>{{ t.suffix }}</small></button>
                                            </div>
                                            <div class="col-md-4">
                                                <label class="small font-weight-bold">数量(수량)</label>
                                                <b-form-input v-model.number="labelForm.palletCount" type="number" size="sm" min="1" max="50"></b-form-input>
                                            </div>
                                            <div class="col-md-8 d-flex align-items-end">
                                                <b-button variant="success" size="sm" block @click="generatePalletLabels" :disabled="labelLoading">🔲 生成托盘(파렛트 생성)</b-button>
                                            </div>
                                        </div>
                                    </b-card>
                                </div>
                            </div>
                            <b-card>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="font-weight-bold mb-0">📋 今天生成的标签(오늘 생성된 라벨)</h6>
                                    <div>
                                        <b-button variant="outline-secondary" size="sm" class="mr-1" @click="loadTodayLabels">🔄 刷新(새로고침)</b-button>
                                        <b-button variant="outline-primary" size="sm" class="mr-1" @click="printLabels('box')" :disabled="todayBoxLabels.length===0">🖨️ 箱子全部打印(박스 전체인쇄)</b-button>
                                        <b-button variant="outline-success" size="sm" @click="printLabels('pallet')" :disabled="todayPalletLabels.length===0">🖨️ 托盘全部打印(파렛트 전체인쇄)</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="small font-weight-bold text-primary">📦 箱子(박스) ({{ todayBoxLabels.length }})</h6>
                                        <div class="table-responsive" style="max-height:300px;overflow-y:auto">
                                            <table class="table table-bordered table-sm">
                                                <thead class="thead-light"><tr><th>标签ID(라벨ID)</th><th>公司(업체)</th><th>形式(형태)</th><th>托盘(파렛트)</th><th></th></tr></thead>
                                                <tbody>
                                                    <tr v-for="l in todayBoxLabels" :key="l._id">
                                                        <td class="small" style="white-space:pre-line">{{ l.labelId }}</td>
                                                        <td>{{ l.companyid }}</td>
                                                        <td><span class="badge" :style="outboundTypeStyle(outboundTypeOfBox(l))">{{ outboundTypeText(outboundTypeOfBox(l)) }}</span></td>
                                                        <td class="small">{{ l.palletLabelId || '-' }}</td>
                                                        <td><b-button size="sm" variant="outline-dark" @click="printSingleLabel(l)">🖨️</b-button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="small font-weight-bold text-success">🔲 托盘(파렛트) ({{ todayPalletLabels.length }})</h6>
                                        <div class="table-responsive" style="max-height:300px;overflow-y:auto">
                                            <table class="table table-bordered table-sm">
                                                <thead class="thead-light"><tr><th>标签ID(라벨ID)</th><th>公司(업체)</th><th>形式(형태)</th><th>箱数(박스수)</th><th></th></tr></thead>
                                                <tbody>
                                                    <tr v-for="l in todayPalletLabels" :key="l._id">
                                                        <td class="small">{{ l.labelId }}</td>
                                                        <td>{{ l.companyid }}</td>
                                                        <td><span class="badge" :style="outboundTypeStyle(l.shipmentType)">{{ outboundTypeText(l.shipmentType) }}</span></td>
                                                        <td>{{ (l.boxes||[]).length }}</td>
                                                        <td><b-button size="sm" variant="outline-dark" @click="printSingleLabel(l)">🖨️</b-button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                            <!-- 托盘号箱号扫描确认以及扫描出库 — 托盘号 먼저 → 箱号 연속(2026-10 YZY). 저장은 기존 mapBoxToPallet.
                                 无托盘号 扫描出库 = 박스만 찍으면 바로 출고완료(/api/warehouse/outbound/scanBox) — 待出库/已出库 목록을 다시 읽는다 -->
                            <b-card class="mt-3">
                                <h6 class="font-weight-bold mb-3">📱 托盘号箱号扫描确认以及扫描出库(파렛트·박스 스캔 확인 및 스캔 출고)</h6>
                                <pallet-box-scan :pallets="todayPalletLabels" @mapped="onPalletMapped" @shipped="search"></pallet-box-scan>
                            </b-card>
                        </b-tab>
                        <!-- 待出库列表(출고대기) — 예전 「出库完成处理」 탭(2026-10 YZY 개명·정리). 상태는 그대로 출고대기.
                             托盘号箱号扫描确认 으로 박스가 파렛트에 매핑되면 박스 라벨(Labels.palletLabelId)에서 托盘号를 붙여 파렛트별로 묶는다
                             (入库列表 엑셀 「파렛트번호」 칸과 같은 출처). 출고완료 처리하면 已出库列表 로 간다 -->
                        <b-tab v-if="showSection('outbound')">
                            <template #title>🚚 待出库列表(출고대기) {{ outboundList.length }}
                                <b-badge v-if="pendingTotal > 0" variant="warning" class="ml-1" title="待手动匹配(수동 매칭 대기)">{{ pendingTotal }}</b-badge>
                            </template>
                            <!-- 待手动匹配(수동 매칭 대기) — 출고일·파일별 남은 행(최근 60일). 별도 메뉴였다가 이 탭 맨 위로 합쳤다(2026-10-07 YZY 「合并」).
                                 처리는 아래 수동 매칭 창 그대로(#1144 다중 선택·수량 배분). 옛 주소 outboundmanualmatch → ?view=manual 로 여기 -->
                            <div ref="manualZone" class="border rounded p-2 mb-3" :class="pendingFiles.length ? 'border-warning' : 'bg-light'">
                                <div class="d-flex align-items-center flex-wrap">
                                    <span class="font-weight-bold mr-2">⚠️ 待手动匹配(수동 매칭 대기) — 最近60天(최근 60일)</span>
                                    <b-badge variant="warning" class="p-2 mr-2">{{ pendingTotal }}行</b-badge>
                                    <b-spinner v-if="pendingBusy" small variant="primary"></b-spinner>
                                </div>
                                <div v-if="!pendingBusy && !pendingFiles.length" class="small text-muted mt-1">没有需要手动匹配的行(수동 매칭할 행이 없습니다)</div>
                                <template v-else-if="pendingFiles.length">
                                    <small class="text-muted d-block mt-1 mb-2">自动出库后剩下的行(자동 출고 뒤 남은 행 — 후보가 여러 건이거나 수량이 안 맞는 행). 点「手动匹配」逐行确认(「手动匹配」을 눌러 행마다 확정)</small>
                                    <table class="table table-sm table-bordered bg-white mb-0">
                                        <thead class="thead-light">
                                            <tr><th>出库日期(출고일)</th><th>文件(파일)</th><th>待手动/未匹配(수동 대기/매칭 실패)</th><th>已出库(반영)</th><th></th></tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="f in pendingFiles" :key="'pf-' + f._id">
                                                <td class="small">{{ f.date }}</td>
                                                <td class="small">{{ f.fileName }}
                                                    <div v-if="f.autoJob && f.autoJob.status === 'running'" class="text-primary">处理中(자동 출고 처리 중)…</div>
                                                    <div v-else-if="f.autoJob && (f.autoJob.status === 'interrupted' || f.autoJob.status === 'failed')" class="text-danger">
                                                        {{ f.autoJob.status === 'interrupted' ? '自动出库中断(자동 출고 중단됨)' : '自动出库失败(자동 출고 실패): ' + (f.autoJob.error || '') }}
                                                        <b-button size="sm" variant="outline-danger" class="py-0 ml-1" :disabled="whUpload.busy" @click="rerunAutoJob(f)">重新执行(다시 실행)</b-button>
                                                    </div>
                                                </td>
                                                <td class="small"><span class="text-warning font-weight-bold">{{ f.summary ? f.summary.대기 : 0 }}</span> / <span class="text-danger">{{ f.summary ? f.summary.미매칭 : 0 }}</span></td>
                                                <td class="small">{{ f.summary ? f.summary.반영 + ' / ' + f.summary.행 : '' }}</td>
                                                <td class="text-nowrap">
                                                    <b-button size="sm" variant="primary" :disabled="whUpload.busy || outJobRunning(f)" @click="openOutFile(f)">手动匹配(수동 매칭)</b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </div>
                            <!-- 창고가 만든 출고리스트를 그대로 올린다. 되돌리기 어려우므로 매칭 결과를 먼저 보여준다. -->
                            <!-- 출고리스트는 출고일(중국 날짜)별로 서버에 저장한다(2026-10-06 YZY) — 다음날 그 날짜를 열어도 그대로 있고, 箱单发票 도 같은 것을 읽는다 -->
                            <div class="border rounded p-2 mb-3 bg-light">
                                <div class="d-flex align-items-center flex-wrap">
                                    <span class="font-weight-bold mr-2">📄 出库清单上传(출고리스트 업로드)</span>
                                    <span class="small mr-1">出库日期(출고일)</span>
                                    <input type="date" v-model="outDate" class="form-control form-control-sm mr-3" style="width:160px" :disabled="whUpload.busy">
                                    <input type="file" class="form-control-file" style="width:auto" accept=".xlsx,.xls"
                                        ref="whExportFile" :disabled="whUpload.busy || !outDate" @change="onWhExportFile">
                                    <span v-if="whUpload.busy && whUpload.mode==='export'" class="ml-3 text-primary">
                                        <b-spinner small></b-spinner> {{ whUpload.step }}
                                    </span>
                                </div>
                                <small class="text-muted d-block mt-1">
                                    上传后保存到服务器，能自动匹配的在后台自动出库，有问题的在上面「待手动匹配」处理 — 与「生成箱单发票」上传相同(올리면 출고일별로 서버에 저장 · 매칭 확정 행은 서버가 백그라운드로 출고완료 — 화면은 바로 써도 된다 · 남은 행은 위 「待手动匹配」 구역에서. 生成箱单发票 에서 올려도 똑같다). 같은 이름 파일을 다시 올리면 교체(이미 나간 행은 두 번 안 나간다).
                                </small>
                                <div v-if="outFilesBusy" class="small text-primary mt-2"><b-spinner small></b-spinner> 读取中(읽는 중)…</div>
                                <div v-else-if="!outFiles.length" class="small text-muted mt-2">{{ outDate }} 没有保存的出库清单(저장된 출고리스트 없음)</div>
                                <table v-else class="table table-sm table-bordered bg-white mt-2 mb-0">
                                    <thead class="thead-light">
                                        <tr><th>文件(파일)</th><th>行(행)</th><th>自动出库/待手动/未匹配(자동 출고/수동 대기/매칭 실패)</th><th>已出库(반영)</th><th>上传(올린 사람·시각)</th><th></th></tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="f in outFiles" :key="f._id">
                                            <td class="small">{{ f.fileName }}<span v-if="f.version > 1" class="text-muted"> · v{{ f.version }}</span>
                                                <!-- 자동 출고는 서버 백그라운드(2026-10-07 YZY 「页面取消掉 后台进行」·「也不需要显示进度」) — 진행 수 대신 상태만 작게 -->
                                                <div v-if="f.autoJob && f.autoJob.status === 'running'" class="text-primary">处理中(자동 출고 처리 중)…</div>
                                                <div v-else-if="f.autoJob && (f.autoJob.status === 'interrupted' || f.autoJob.status === 'failed')" class="text-danger">
                                                    {{ f.autoJob.status === 'interrupted' ? '自动出库中断(자동 출고 중단됨 — 서버 재시작)' : '自动出库失败(자동 출고 실패): ' + (f.autoJob.error || '') }}
                                                    <b-button size="sm" variant="outline-danger" class="py-0 ml-1" :disabled="whUpload.busy" @click="rerunAutoJob(f)">重新执行(다시 실행)</b-button>
                                                </div>
                                                <div v-if="f.keptReason" class="text-danger">部分出库保留(일부 출고 유지 — 삭제 못 한 행): {{ keptReasonText(f.keptReason) }}</div>
                                            </td>
                                            <td class="small">{{ f.summary ? f.summary.행 : '' }}</td>
                                            <td class="small">
                                                <!-- 옛 저장본(자동출고 칸 없음)은 확정/확인필요/실패 그대로 -->
                                                <template v-if="f.summary && f.summary.대기 !== undefined">
                                                    <span class="text-success">{{ f.summary.자동출고 }}</span> /
                                                    <span class="text-warning">{{ f.summary.대기 }}</span> /
                                                    <span class="text-danger">{{ f.summary.미매칭 }}</span>
                                                </template>
                                                <template v-else-if="f.summary">
                                                    <span class="text-success">{{ f.summary.확정 }}</span> /
                                                    <span class="text-warning">{{ f.summary.확인필요 }}</span> /
                                                    <span class="text-danger">{{ f.summary.실패 }}</span>
                                                </template>
                                            </td>
                                            <td class="small">{{ f.summary ? f.summary.반영 + ' / ' + f.summary.행 : '' }}</td>
                                            <td class="small text-muted">{{ f.uploadedBy }} {{ f.uploadedAt ? new Date(f.uploadedAt).toLocaleString() : '' }}</td>
                                            <td class="text-nowrap">
                                                <b-button size="sm" variant="outline-primary" :disabled="whUpload.busy || outJobRunning(f)" @click="openOutFile(f)">手动匹配(수동 매칭)<template v-if="f.summary && f.summary.대기"> {{ f.summary.대기 }}</template></b-button>
                                                <b-button v-if="f.lastAutoBatch && f.summary && f.summary.자동출고 && !outJobRunning(f)" size="sm" variant="outline-danger" class="ml-1" :disabled="whUpload.busy" @click="undoAutoBatch(f)">撤销本次自动出库(이번 자동 출고 취소)</b-button>
                                                <b-button size="sm" variant="link" class="text-danger" :disabled="whUpload.busy || outJobRunning(f)" @click="deleteOutFile(f)">删除文件(파일 삭제)</b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
                                <span class="font-weight-bold">
                                    出库待发(출고대기) {{ outboundList.length }}件 · 已扫托盘(파렛트 매핑) {{ outboundGroups.filter(g => g.pallet).length }}托
                                    <label class="small font-weight-normal ml-3 mb-0">
                                        <input type="checkbox" v-model="outboundOnlyPallet"> 只看已扫托盘<small>(파렛트 매핑된 것만)</small>
                                    </label>
                                </span>
                                <button class="btn btn-sm btn-danger" @click="processOutbound" :disabled="selectedOutbound.length===0">
                                    ✅ 已选(선택) {{ selectedOutbound.length }}件 → 出库完成(출고완료)
                                </button>
                            </div>
                            <div v-if="outboundList.length===0" class="text-center text-muted py-5"><p>没有出库待发项(출고대기 건이 없습니다).</p></div>
                            <div v-else class="table-responsive" style="max-height:560px;overflow-y:auto;">
                                <table class="table table-bordered table-sm table-hover">
                                    <thead class="thead-light">
                                        <tr>
                                            <th style="width:40px"><input type="checkbox" @change="toggleAllOutbound($event)" :checked="selectedOutbound.length===outboundVisible.length&&outboundVisible.length>0"></th>
                                            <th>托盘号(파렛트)</th><th>箱号(박스)</th><th>货主(화주)</th><th>商品名(상품명)</th><th>SKUID</th><th>条码(바코드)</th><th>数量(수량)</th><th>状态变更日(상태변경일)</th><th>📦箱子(박스 지정)</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="g in outboundGroups" :key="'og-' + (g.pallet || '-')">
                                        <tr :class="g.pallet ? 'table-info' : 'table-light'">
                                            <td><input type="checkbox" :checked="g.rows.every(r => selectedOutbound.includes(r._id))" @change="toggleGroupOutbound(g, $event.target.checked)"></td>
                                            <td colspan="9" class="font-weight-bold">
                                                <template v-if="g.pallet">🔲 {{ g.pallet === 'NOPALLET' ? 'NOPALLET(无托盘)' : g.pallet }}</template>
                                                <template v-else>未扫托盘<small>(파렛트 미매핑)</small></template>
                                                <span v-if="g.info && g.info.customsType" class="badge badge-light border ml-2">{{ customsTypeText(g.info.customsType) }}</span>
                                                <span v-if="g.info && g.info.shipmentType" class="badge ml-1" :style="outboundTypeStyle(g.info.shipmentType)">{{ outboundTypeText(g.info.shipmentType) }}</span>
                                                <span class="small font-weight-normal ml-2">{{ g.boxCount }}箱 · {{ g.rows.length }}件 · {{ g.qty }}个</span>
                                            </td>
                                        </tr>
                                        <tr v-for="item in g.rows" :key="item._id">
                                            <td><input type="checkbox" :value="item._id" v-model="selectedOutbound"></td>
                                            <td class="small">{{ item._pallet }}</td>
                                            <td class="small text-nowrap">{{ item._box }}
                                                <!-- 箱子分配에서 이 박스만 发货方式를 바꿨으면 표시 -->
                                                <span v-if="item._boxShip" class="badge d-block mt-1" :style="outboundTypeStyle(item._boxShip)" :title="item._boxAddr">{{ outboundTypeText(item._boxShip) }}</span>
                                            </td>
                                            <td>{{ item.companyid }}</td>
                                            <td class="text-truncate" style="max-width:200px">{{ item.상품명 }}</td>
                                            <td>{{ item.SKUID }}</td><td>{{ item.바코드 }}</td>
                                            <td>{{ item.구매요청수량 }}</td>
                                            <td>{{ getOutboundDate(item) }}</td>
                                            <td>
                                                <b-form-select v-if="!item._box" v-model="outboundBoxMap[item._id]" size="sm" style="min-width:120px">
                                                    <option value="">未指定(미지정)</option>
                                                    <option v-for="b in todayBoxLabels" :key="'ob-'+b._id" :value="b.labelId">{{ b.labelId.replace(/\n/g,'-') }}</option>
                                                </b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-tab>
                        <b-tab v-if="showSection('outbound')" title="🧾 生成箱单发票(인보이스·패킹리스트)" lazy>
                            <!-- ② 출고리스트 업로드 = 待出库 탭과 같은 길(저장·자동 출고·수동 매칭) — 2026-10-07 YZY 「合并到一起」 -->
                            <invoice-generator :save-outbound="saveOutboundFromInvoice" :delete-outbound="deleteOutFile"></invoice-generator>
                        </b-tab>
                        <!-- 箱单发票列表 — 사이드바 메뉴에서 이리로 옮겼다(2026-10-04 YZY 「挪到 生成箱单发票 旁边」) -->
                        <b-tab v-if="showSection('outbound')" title="📑 箱单发票列表(서류목록)" lazy>
                            <invoice-record-list embedded></invoice-record-list>
                        </b-tab>
                        <!-- 已出库列表 — 지금까지 출고완료된 전체(2026-10 YZY). 화면 검색(위 货主 필터)이 받은 출고완료 건을 그대로 보여준다(조회 전용) -->
                        <b-tab v-if="showSection('outbound')" :title="'✅ 已出库列表(출고완료) ' + shippedList.length" lazy>
                            <CDataTable :headers="shippedHeaders" :items="shippedRows" item-key="_id" storage-key="warehouseManagement.shipped"></CDataTable>
                        </b-tab>
                        <b-tab v-if="showSection('stock')" title="🔍 海外仓库库存修改(해외창고 재고 수정)">
                            <b-card class="mb-3">
                                <h6 class="font-weight-bold mb-3">海外仓库库存修改(해외창고 재고 수정)</h6>
                                <p class="small text-muted mb-2">修改海外仓库库存数量。搜索后输入要修改的数量(해외창고 재고 수량을 수정합니다. 검색 후 수정할 항목의 수량을 입력해주세요).</p>
                                <!-- 재고리스트는 스냅샷이라(다음 업로드가 오차를 바로잡는다) 확인 없이 바로 반영한다. -->
                                <div class="border rounded p-2 mb-3 bg-light">
                                    <div class="d-flex align-items-center flex-wrap">
                                        <span class="font-weight-bold mr-3">📄 库存清单上传(재고리스트 업로드)</span>
                                        <input type="file" class="form-control-file" accept=".xlsx,.xls"
                                            ref="whStockFile" :disabled="whUpload.busy" @change="onWhStockFile">
                                        <span v-if="whUpload.busy && whUpload.mode==='stock'" class="ml-3 text-primary">
                                            <b-spinner small></b-spinner> {{ whUpload.step }}
                                        </span>
                                    </div>
                                    <small class="text-muted d-block mt-1">
                                        올린 수량이 현재 재고가 됩니다(스냅샷). 여러 업체가 한 파일에 섞여 있어도 됩니다.
                                    </small>
                                    <div v-if="whUpload.mode==='stock' && whUpload.result" class="mt-2 small">
                                        <b-alert show variant="success" class="py-2 mb-1">
                                            반영 완료 — 재고 {{ whUpload.result.stocked || 0 }}건,
                                            수량만 {{ whUpload.result.qtyOnly || 0 }}건,
                                            합포장 구성품 {{ whUpload.result.component || 0 }}건,
                                            건너뜀 {{ whUpload.result.skip || 0 }}건
                                        </b-alert>
                                        <b-alert v-if="whUpload.issues.length" show variant="warning" class="py-2 mb-0">
                                            읽지 못한 행 {{ whUpload.issues.length }}건 —
                                            <span v-for="(i, idx) in whUpload.issues.slice(0,3)" :key="'si-'+idx">행{{ i.line }} {{ i.reason }}<span v-if="idx<2 && idx<whUpload.issues.length-1">, </span></span>
                                            <span v-if="whUpload.issues.length>3"> 외 {{ whUpload.issues.length-3 }}건</span>
                                        </b-alert>
                                    </div>
                                </div>
                                <div v-if="auditList.length===0" class="text-center text-muted py-5"><p>搜索后显示海外仓库库存(중국재고/출고대기)(검색 후 해외창고 재고가 표시됩니다).</p></div>
                                <div v-else>
                                    <div class="d-flex justify-content-between mb-2">
                                        <span class="font-weight-bold">修改对象(수정 대상) {{ auditList.length }}件</span>
                                        <b-button variant="primary" size="sm" @click="submitAudit" :disabled="auditProcessing">
                                            <b-spinner small v-if="auditProcessing"></b-spinner>
                                            {{ auditProcessing ? '处理中(처리중)...' : '💾 保存修改结果(수정 결과 저장)' }}
                                        </b-button>
                                    </div>
                                    <div class="table-responsive" style="max-height:500px;overflow-y:auto;">
                                        <table class="table table-bordered table-sm table-hover">
                                            <thead class="thead-light">
                                                <tr><th>货主(화주)</th><th>商品名(상품명)</th><th>条码(바코드)</th><th>系统数量(시스템수량)</th><th>修改数量(수정수량)</th><th>差异(차이)</th><th>备注(메모)</th></tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="a in auditList" :key="a._id" :class="{'table-warning': a.실사수량 !== null && a.실사수량 !== a.구매요청수량}">
                                                    <td>{{ a.companyid }}</td>
                                                    <td class="text-truncate" style="max-width:200px">{{ a.상품명 }}</td>
                                                    <td>{{ a.바코드 }}</td>
                                                    <td class="text-center">{{ a.구매요청수량 }}</td>
                                                    <td><b-form-input v-model.number="a.실사수량" type="number" size="sm" min="0" style="width:80px;"></b-form-input></td>
                                                    <td class="text-center" :class="{'text-danger': a.실사수량 !== null && a.실사수량 !== a.구매요청수량}">
                                                        {{ a.실사수량 !== null ? a.실사수량 - a.구매요청수량 : '-' }}
                                                    </td>
                                                    <td><b-form-input v-model="a.실사메모" size="sm" placeholder="备注(메모)" style="width:120px;"></b-form-input></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </b-card>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
        <!-- 출고리스트 미리보기: 확정을 받고 나서 반영한다 -->
        <!-- 수동 매칭(待手动匹配) — 업로드 때 자동 출고된 행은 빠지고 남은 행(확인필요·실패·취소한 행)만 기본으로 보인다(2026-10-07 YZY 「有问题的单独显示一个页面手动匹配」).
             已出库 = 이미 나간 행 — 행마다 撤销(출고 취소) -->
        <b-modal v-model="showWhPreview" size="xl" scrollable
            :title="'待手动匹配(수동 매칭) — ' + (whUpload.outDate ? whUpload.outDate + ' · ' : '') + whUpload.fileName"
            ok-title="确认出库(선택 행 출고 처리)" cancel-title="关闭(닫기)" @ok="confirmWhExport"
            :ok-disabled="whUpload.busy || whPreviewReady === 0">
            <b-alert v-if="whUpload.autoMsg" show variant="info" class="py-2 small mb-2">{{ whUpload.autoMsg }}</b-alert>
            <!-- 눌러서 해당 줄만 본다. 1,700줄짜리 파일에서 손봐야 할 줄만 골라내려고 스크롤하는 건 무리다. -->
            <div class="d-flex flex-wrap mb-2 align-items-center">
                <b-badge :variant="whPreviewFilter==='pending' ? 'dark' : 'light'" class="mr-2 p-2 border"
                    style="cursor:pointer" @click="whPreviewFilter='pending'">待处理(남은 행) {{ whPendingCount }}</b-badge>
                <b-badge :variant="whPreviewFilter==='done' ? 'info' : 'light'" class="mr-2 p-2 border"
                    style="cursor:pointer" @click="whPreviewFilter='done'">已出库(출고됨) {{ whUpload.preview.length - whPendingCount }}</b-badge>
                <b-badge :variant="whPreviewFilter==='all' ? 'dark' : 'light'" class="mr-2 p-2 border"
                    style="cursor:pointer" @click="whPreviewFilter='all'">전체 {{ whUpload.preview.length }}</b-badge>
                <b-badge :variant="whPreviewFilter==='ok' ? 'success' : 'light'" class="mr-2 p-2 border"
                    style="cursor:pointer" @click="whPreviewFilter='ok'">확정 {{ whPreviewCount.ok }}</b-badge>
                <b-badge :variant="whPreviewFilter==='ambiguous' ? 'warning' : 'light'" class="mr-2 p-2 border"
                    style="cursor:pointer" @click="whPreviewFilter='ambiguous'">확인필요 {{ whPreviewCount.ambiguous }}</b-badge>
                <b-badge :variant="whPreviewFilter==='failed' ? 'danger' : 'light'" class="mr-2 p-2 border"
                    style="cursor:pointer" @click="whPreviewFilter='failed'">실패 {{ whPreviewCount.failed }}</b-badge>
                <b-badge :variant="whPreviewFilter==='issues' ? 'secondary' : 'light'" class="mr-2 p-2 border"
                    style="cursor:pointer" @click="whPreviewFilter='issues'">읽지 못한 행 {{ whUpload.issues.length }}</b-badge>
                <b-badge v-if="whMismatchCount" :variant="whPreviewFilter==='mismatch' ? 'danger' : 'light'"
                    class="mr-2 p-2 border" style="cursor:pointer" @click="whPreviewFilter='mismatch'">
                    수량 불일치 {{ whMismatchCount }}
                </b-badge>
                <b-badge variant="primary" class="p-2 ml-auto">처리 대상 {{ whPreviewReady }}건</b-badge>
            </div>
            <b-alert v-if="whMismatchCount" show variant="danger" class="py-2 small mb-2">
                창고 파일의 <b>주문수량</b>과 우리가 가진 <b>구매요청수량</b>이 다른 행이
                {{ whMismatchCount }}건 있습니다. 표에서 빨간 표시를 확인해 주세요.
                이 수량으로 매입단가를 나누기 때문에, 다르면 단가가 그만큼 틀어집니다.
                <b>반영은 그대로 진행되고 수량을 임의로 바꾸지 않습니다.</b>
            </b-alert>
            <p class="small text-muted mb-2">
                합포장 구성품행("/")은 수량·상태를 바꾸지 않고 이력만 남깁니다.
                대표행은 수량이 모자라면 자동으로 나갈 몫과 남을 몫으로 나뉩니다.
            </p>
            <p v-if="whUpload.extra && whUpload.extra.입고ID < 0 && whUpload.extra.blNo < 0"
                class="small text-muted mb-2">
                ℹ️ 이 파일에는 <b>입고ID</b>·<b>BL번호</b> 열이 없습니다. 출고 반영은 지금까지와 똑같이 됩니다.
                두 열이 있으면 통관 추적까지 자동으로 이어집니다.
            </p>
            <!-- '읽지 못한 행'은 매칭 대상이 아니라 엑셀에서 아예 못 읽은 줄이라 표가 아니라 목록으로 보여준다 -->
            <div v-if="whPreviewFilter==='issues'" class="table-responsive" style="max-height:480px;overflow-y:auto;">
                <div v-if="!whUpload.issues.length" class="text-center text-muted py-4">읽지 못한 행이 없습니다.</div>
                <table v-else class="table table-bordered table-sm">
                    <thead class="thead-light"><tr><th style="width:90px">行(행)</th><th>사유</th></tr></thead>
                    <tbody>
                        <tr v-for="(i, idx) in whUpload.issues" :key="'wi-'+idx">
                            <td>{{ i.line }}</td><td class="small">{{ i.reason }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="table-responsive" style="max-height:480px;overflow-y:auto;">
                <div v-if="!whPreviewRows.length" class="text-center text-muted py-4">해당하는 행이 없습니다.</div>
                <table v-else class="table table-bordered table-sm table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th style="width:36px"></th>
                            <th>行(행)</th><th>货主(화주)</th><th>条码(바코드)</th>
                            <th title="上: 出库清单(엑셀 주문번호) / 下: 采购单(구매요청 1688주문번호) — 不同时红色(다르면 빨간색)">1688订单号(1688 주문번호)</th>
                            <th>商品名(상품명)</th><th>选项(옵션)</th>
                            <th>数量(수량)</th><th>📦箱子(박스)</th><th>入库ID·B/L</th><th>匹配(매칭)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="p in whPreviewRows" :key="'wp-'+p.line"
                            :class="{'table-warning': p.status==='ambiguous', 'table-danger': p.status==='failed'}">
                            <td class="text-center">
                                <template v-if="p.반영">
                                    <b-badge :variant="String(p.반영.배치 || '').indexOf('auto-') === 0 ? 'info' : 'success'" class="d-block mb-1">
                                        {{ String(p.반영.배치 || '').indexOf('auto-') === 0 ? '自动(자동)' : '已出库' }}
                                    </b-badge>
                                    <b-button size="sm" variant="link" class="text-danger p-0 small" :disabled="whUpload.busy" @click="undoOutRows([p.line])">撤销(취소)</b-button>
                                </template>
                                <input v-else type="checkbox" v-model="p.checked" :disabled="!p.선택_id">
                            </td>
                            <td>{{ p.line }}</td>
                            <td>{{ p.companyid }}</td>
                            <td class="small">{{ p.바코드 }}</td>
                            <!-- 1688订单号 — 엑셀 행 주문번호(19번 칸)와 매칭(고른) 구매요청의 1688주문번호. 다르면 빨간색(2026-10-06 YZY) -->
                            <td class="small" style="min-width:150px;overflow-wrap:anywhere">
                                <div>{{ p.주문번호 || '-' }}</div>
                                <div v-if="whDoc1688(p)" :class="whOrderDiff(p) ? 'text-danger font-weight-bold' : 'text-muted'"
                                    :title="whOrderDiff(p) ? '出库清单与采购单的1688订单号不同(엑셀과 구매요청의 1688 주문번호가 다릅니다)' : '采购单(구매요청)'">
                                    {{ whOrderDiff(p) ? '≠ ' : '' }}{{ whDoc1688(p) }}
                                </div>
                            </td>
                            <td style="min-width:200px;overflow-wrap:anywhere">
                                {{ p.상품명 }}
                                <b-badge v-if="!p.대표여부" variant="light" class="ml-1">구성품</b-badge>
                            </td>
                            <td style="min-width:160px;overflow-wrap:anywhere">{{ p.옵션 }}</td>
                            <td class="text-center">
                                {{ p.대표여부 ? p.수량 : (p.합포장수량 !== null && p.합포장수량 !== undefined ? '/ (' + p.합포장수량 + ')' : '/') }}
                                <!-- 같은 박스에 두 번 나눠 담아 수량 행이 여럿이던 것을 합친 경우 — 원래 행 번호를 근거로 보여준다 -->
                                <div v-if="p.합산행 && p.합산행.length" class="small text-muted" style="white-space:nowrap">
                                    合计(합산) {{ p.합산행.join('+') }}행
                                </div>
                            </td>
                            <td style="white-space:pre-line">{{ p.박스번호 }}</td>
                            <td class="small" style="min-width:130px">
                                <div v-if="p.입고ID">🏷️ {{ p.입고ID }}</div>
                                <div v-if="p.blNo">🚢 {{ p.blNo }}</div>
                                <span v-if="p.대표여부 && !p.입고ID && !p.blNo" class="text-muted">-</span>
                            </td>
                            <td style="min-width:280px">
                                <span v-if="p.status==='ok' && p.matched" class="small">
                                    ✅ {{ p.matched.상품명 }}
                                    <span class="text-muted">({{ p.matched.진행현황 || '상태없음' }}, {{ whQtyLabel(p.matched) }})</span>
                                    <!-- 실제 입고수량 기준(입고 전이면 구매요청수량) — 2026-10-06 YZY -->
                                    <b-badge v-if="p.대표여부 && p.수량 < whBaseQty(p.matched)" variant="info" class="ml-1">
                                        분할 {{ p.수량 }}/{{ whBaseQty(p.matched) }}
                                    </b-badge>
                                    <!-- 창고가 아는 주문 전체 수량과 우리가 아는 수량이 다르다.
                                         매입가는 우리 수량으로 나누므로 이게 틀리면 단가가 틀린다.
                                         값을 바꾸지는 않고 알려만 준다 — 어느 쪽이 맞는지는 사람이 판단할 일이다. -->
                                    <b-badge v-if="whQtyMismatch(p)" variant="danger" class="ml-1"
                                        :title="'창고 주문수량 ' + p.주문수량 + '개 / 우리 기록 ' + p.matched.구매요청수량 + '개 × 판매구성 ' + whCompose(p.matched)">
                                        수량 불일치 {{ p.주문수량 }}↔{{ p.matched.구매요청수량 * whCompose(p.matched) }}
                                    </b-badge>
                                </span>
                                <!-- 후보 여러 건의 수량 합 = 행 수량 → 서버가 나눠 배정(자동 확정, 「合并数量一致 就自动匹配」 2026-10-06 YZY). 원장·선적은 구매요청마다 따로 -->
                                <div v-else-if="p.status==='ok' && p.자동배정" class="small">
                                    ✅ 自动分配(자동 배정) {{ p.배정.length }}件 · 合计(합계) {{ whPickSum(p) }}
                                    <div v-for="a in p.배정" :key="'wa-'+p.line+'-'+a._id" class="text-muted">
                                        · {{ (whCand(p, a._id) || {}).옵션1_중국어 }} / {{ a.수량 }}개 / {{ (whCand(p, a._id) || {}).진행현황 || '상태없음' }} / {{ (whCand(p, a._id) || {}).화주주문번호 }}
                                    </div>
                                </div>
                                <!-- 확인필요 대표행 — 후보를 여러 건 고를 수 있다(한 행을 구매요청 여러 건이 함께 출고). 기본 수량 = 각 건 입고수량, 합이 다르면 경고·직접 입력 -->
                                <div v-else-if="p.status==='ambiguous' && p.대표여부" class="small">
                                    <div class="text-muted mb-1">可多选采购单(후보 여러 건 선택 가능) · {{ p.candidates.length }}件</div>
                                    <div v-for="c in p.candidates" :key="'c-'+p.line+'-'+c._id" class="d-flex align-items-center mb-1">
                                        <input type="checkbox" class="wh-pick mr-1" :checked="whPicked(p, c)" @change="whTogglePick(p, c, $event.target.checked)">
                                        <span class="mr-2">{{ c.companyid !== p.companyid ? '[' + c.companyid + '] ' : '' }}{{ c.옵션1_중국어 }} / {{ whQtyLabel(c) }} / {{ c.진행현황 || '상태없음' }} / {{ c.화주주문번호 }}</span>
                                        <input v-if="whPicked(p, c) && p.배정.length > 1" type="number" min="0" class="form-control form-control-sm wh-pick-qty"
                                            style="width:72px" :value="whPickQty(p, c)" @input="whSetPickQty(p, c, $event.target.value)">
                                    </div>
                                    <div v-if="p.배정.length > 1 && whPickSum(p) !== p.수량" class="text-danger font-weight-bold">
                                        ⚠ 合计(합계) {{ whPickSum(p) }} ≠ 本行数量(행 수량) {{ p.수량 }} — 请直接输入(수량을 직접 고쳐 주세요)
                                    </div>
                                </div>
                                <b-form-select v-else-if="p.status==='ambiguous'" v-model="p.선택_id" size="sm"
                                    @change="p.checked = !!p.선택_id">
                                    <option value="">선택 안 함 ({{ p.candidates.length }}건 후보)</option>
                                    <option v-for="c in p.candidates" :key="'c-'+p.line+'-'+c._id" :value="c._id">
                                        {{ c.companyid !== p.companyid ? '[' + c.companyid + '] ' : '' }}{{ c.옵션1_중국어 }} / {{ whQtyLabel(c) }} / {{ c.진행현황 || '상태없음' }} / {{ c.화주주문번호 }}
                                    </option>
                                </b-form-select>
                                <div v-if="p.status==='ambiguous' && p.reason" class="small text-warning">⚠ {{ p.reason }}</div>
                                <div v-if="p.합포장추정" class="small" :class="p.status==='ok' ? 'text-success' : 'text-warning'">
                                    📦 合并打包(합포장) → {{ p.대표상품명 }}
                                    · {{ p.합포장근거 ? p.합포장근거.판정 : '확인필요' }}
                                    <template v-if="p.합포장수량 !== null"> · 出库(출고) {{ p.합포장수량 }}개</template>
                                    <div v-if="p.합포장근거" class="text-muted">근거: 「{{ p.합포장근거.문구 }}」 {{ p.합포장근거.사유 }}</div>
                                </div>
                                <span v-if="p.status!=='ok' && p.status!=='ambiguous'" class="small text-danger">❌ {{ p.reason }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="whUpload.issues.length" class="mt-2">
                <b-alert show variant="warning" class="py-2 mb-0 small">
                    엑셀에서 읽지 못한 행 {{ whUpload.issues.length }}건 (반영되지 않습니다):
                    <span v-for="(i, idx) in whUpload.issues.slice(0,5)" :key="'ei-'+idx">행{{ i.line }} {{ i.reason }}<span v-if="idx<4 && idx<whUpload.issues.length-1"> / </span></span>
                    <span v-if="whUpload.issues.length>5"> 외 {{ whUpload.issues.length-5 }}건</span>
                </b-alert>
            </div>
        </b-modal>

        <!-- 라벨 프린트 영역 (숨김) -->
        <div class="d-none">
            <div id="labelPrintArea">
                <div v-for="(l, idx) in printLabelList" :key="'pl-'+idx" style="page-break-after:always;text-align:center;padding:20px;">
                    <div style="font-size:20px;font-weight:bold;white-space:pre-line;margin-bottom:10px;">{{ l.labelId }}</div>
                    <barcode :value="l.labelId.replace(/\n/g,'-')" tag="svg" :height="50" :options="{ lineColor:'#000', margin:5, displayValue:false }"></barcode>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { coupassMenuTitle } from './coupassMenu';
import axios from 'axios';
import CDataTable from '@/components/common/CDataTable';
import VueBarcode from 'vue-barcode';
import * as XLSX from 'xlsx';
import { parseWarehouseList } from './warehouseListParser';
import { stripXlsxMedia, u8ToBinaryString, trimAoa } from './warehouseXlsxSlim';
import InvoiceGenerator from './InvoiceGenerator';
import InvoiceRecordList from './InvoiceRecordList';
import PalletBoxScan from './PalletBoxScan';
import { outboundTypeText, outboundTypeStyle, outboundTypeOfBox, boxOutboundKey, customsTypeText } from '@/utils/coupassStatusText';

// 출고일 = 창고(중국) 날짜. 브라우저 시간대와 상관없이 UTC+8 로 센다(箱单发票 方数计划 날짜와 같은 규칙)
function chinaToday() {
    return new Date(Date.now() + 8 * 3600 * 1000).toISOString().slice(0, 10);
}

export default {
    name: 'WarehouseManagement',
    components: { CDataTable, 'barcode': VueBarcode, InvoiceGenerator, InvoiceRecordList, PalletBoxScan },
    // 출고(出库) 메뉴 = outbound 탭만, 재고리스트(库存列表) 페이지에 끼울 때 = stock 탭만(2026-10-03 YZY 재고/출고 분리).
    // 한 컴포넌트를 두 곳이 나눠 쓴다 — 탭 기능·API 는 그대로다. all 이면 예전처럼 전부
    props: {
        section: { type: String, default: 'outbound', validator: v => ['outbound', 'stock', 'all'].includes(v) },
        // 바깥에서 고른 탭 번호(보이는 탭 기준 0부터). 주면 이 컴포넌트의 탭 줄은 숨긴다
        tab: { type: Number, default: null }
    },
    data() {
        return {
      pageTitle: coupassMenuTitle('logis.warehousemanagement'),
            selectdate: 'month',
            startdate: '',
            enddate: '',
            filterCompanyId: '',
            companyids: [],
            showspinner: false,
            // Phase G: showDomesticTabs 제거 — 수동입고/출고처리/재고수정 모두 해외창고용으로 활성화
            activeTab: 0,
            dateOptions: [
                { value: 'today', label: '今天(오늘)' },
                { value: 'week', label: '最近7天(최근7일)' },
                { value: 'month', label: '最近1个月(최근1개월)' },
                { value: '3month', label: '最近3个月(최근3개월)' },
            ],
            // 표를 원시 table 로 그리면 16,023행 + 이력 110,980행이 전부 DOM 에 올라가
            // 셀이 111만 개가 된다 — 탭 전환·클릭이 통째로 버벅인다(2026-09-22 YZY 제보).
            // CDataTable(v-data-table 래퍼)로 페이지 단위만 그린다.
            inventoryHeaders: [
                { text: '货主(화주)', value: 'companyid' },
                { text: '商品名(상품명)', value: '상품명' },
                { text: 'SKUID', value: 'SKUID' },
                { text: '条码(바코드)', value: '바코드' },
                { text: '数量(수량)', value: '구매요청수량', align: 'right' },
                { text: '状态(상태)', value: 'processStatus', isSlot: true },
                { text: '请求日(요청일)', value: '요청일', isSlot: true }
            ],
            historyHeaders: [
                { text: '日期(일시)', value: 'changedAt', isSlot: true },
                { text: '货主(화주)', value: 'companyid' },
                // 1688订单号 우선, 없으면 货主订单号 (2026-10-04 YZY)
                { text: '订单号(주문번호)', value: 'orderNo' },
                { text: '商品名(상품명)', value: '상품명' },
                { text: 'SKUID', value: 'SKUID' },
                { text: '条码(바코드)', value: '바코드' },
                { text: '数量(수량)', value: '수량', align: 'right' },
                { text: '变更前(변경전)', value: 'fromStatus', isSlot: true },
                { text: '变更后(변경후)', value: 'toStatus', isSlot: true },
                { text: '变更者(변경자)', value: 'changedBy' },
                { text: '备注(메모)', value: 'memo' }
            ],
            allStatusData: [],
            sc: { 배송완료:0, 입고작업:0, 출고요청:0, 출고대기:0, 중국재고:0, 출고완료:0, 해외입고중:0, 국내입고중:0 },
            inventoryList: [],
            inventoryStatusFilter: '',
            historyList: [],
            // 입출고이력은 재고 목록과 따로 /api/reqpurchase/getStockHistory 로 받는다(기본 최근 30일).
            historyStartDate: '',
            historyEndDate: '',
            historyLoading: false,
            // 수동 입고 관련
            manualInbound: { companyid: '', 상품명: '', 바코드: '', 수량: 1, 사유: '직접입고', 메모: '' },
            manualInboundProcessing: false,
            // 출고 처리 관련
            outboundList: [],
            selectedOutbound: [],
            outboundBoxMap: {},
            outboundOnlyPallet: false,
            // 箱号 → { palletLabelId, … } / 托盘号 → { customsType, shipmentType, companyid } (/api/labels/boxPallets)
            boxPalletMap: {},
            palletInfoMap: {},
            // 已出库列表 — 출고완료 전체(검색 결과에서)
            shippedList: [],
            shippedHeaders: [
                { text: '出库日(출고일)', value: '_shippedDay' },
                { text: '货主(화주)', value: 'companyid' },
                { text: '商品名(상품명)', value: '상품명' },
                { text: 'SKUID', value: 'SKUID' },
                { text: '条码(바코드)', value: '바코드' },
                { text: '数量(수량)', value: '구매요청수량', align: 'right' },
                { text: '箱号(박스)', value: '_box' },
                { text: '托盘号(파렛트)', value: '_pallet' },
                // 선적(Shipment.blNo) — 箱单发票列表 提单BL 확인 또는 출고리스트 BL번호 열로 채워진다(서버가 _blNo 로 붙여 준다)
                { text: 'BL提单号', value: '_bl' }
            ],
            // 재고 수정 관련
            auditList: [],
            auditProcessing: false,
            // 창고 엑셀 업로드 (출고리스트 / 재고리스트)
            whUpload: {
                busy: false, step: '', mode: '', fileName: '', outDate: '',
                total: 0, done: 0, groups: [], issues: [], preview: [], result: null, autoMsg: '',
                extra: { 입고ID: -1, blNo: -1 }
            },
            showWhPreview: false,
            // 출고리스트 저장본(출고일별, /api/coupassOutboundList/*) — 고른 날짜에 저장된 파일 목록(행·표 없이 요약만)
            outDate: chinaToday(),
            outFiles: [],
            outFilesBusy: false,
            // 待手动匹配 — 남은 행이 있는 파일(최근 60일). 待出库列表 탭 맨 위 구역(2026-10-07 YZY 「合并」)
            pendingFiles: [],
            pendingTotal: 0,
            pendingBusy: false,
            outJobTimer: null,
            // 확인 창에서 어떤 줄만 볼지. all|ok|ambiguous|failed|mismatch|issues
            whPreviewFilter: 'all',
            // 라벨 관리
            // 出库形式 선택지 — 뒤 표시는 라벨 번호에 붙는 접두/코드(박스 Z-, 파렛트 P·KD·H)
            boxTypeOptions: [
                { value: 'milkrun_box', suffix: '(Z-)' }, { value: 'milkrun_pallet', suffix: '(Z-)' },
                { value: 'normal_box', suffix: '' }, { value: 'normal_pallet', suffix: '' }
            ],
            palletTypeOptions: [
                { value: 'milkrun_pallet', suffix: '(P)' }, { value: 'milkrun_box', suffix: '("")' },
                { value: 'normal_box', suffix: '(KD)' }, { value: 'normal_pallet', suffix: '(H)' }
            ],
            labelForm: {
                companyid: '', 담당자이니셜: '',
                boxShipmentType: 'normal_box', boxCount: 1,
                customsType: 'integrated', palletCompanyid: '',
                palletShipmentType: 'normal_box', palletCount: 1,
            },
            todayLabels: [],
            labelLoading: false,
            printLabelList: [],
            // Phase B: 스캔 매핑
        }
    },
    watch: {
        tab: {
            immediate: true,
            handler(v) { if (v !== null) this.activeTab = v; }
        },
        outDate() { this.loadOutFiles(); },
        // 옛 待手动匹配 주소(→ ?view=manual) — 이미 열린 탭(keep-alive)에서도 그 구역으로 간다
        '$route.query.view'(v) {
            if (v === 'manual' && this.$route.name === 'logis.warehousemanagement') this.openManualZone();
        }
    },
    computed: {
        inventoryStatusOptions() {
            return [...new Set(this.inventoryList.map(e => e.processStatus).filter(Boolean))].sort();
        },
        filteredInventory() {
            return this.inventoryList.filter(e => {
                if (this.inventoryStatusFilter && e.processStatus !== this.inventoryStatusFilter) return false;
                return true;
            });
        },
        // 확정·확인필요·실패 수는 아직 안 나간 행만 센다(나간 행은 已出库 로 따로)
        whPreviewCount() {
            const c = { ok: 0, ambiguous: 0, failed: 0 };
            this.whUpload.preview.forEach(p => { if (!p.반영) c[p.status] = (c[p.status] || 0) + 1; });
            return c;
        },
        whPendingCount() {
            return this.whUpload.preview.filter(p => !p.반영).length;
        },
        whPreviewReady() {
            return this.whUpload.preview.filter(p => !p.반영 && p.checked && p.선택_id).length;
        },
        // 창고가 아는 주문 전체 수량 ↔ 우리 구매요청수량이 어긋난 행 수.
        // 표 안에만 두면 스크롤해야 보여서 놓친다.
        whMismatchCount() {
            return this.whUpload.preview.filter(p => this.whQtyMismatch(p)).length;
        },
        // 위 badge 로 고른 줄만 표에 그린다.
        // 걸러내면 그리는 양도 같이 줄어든다 — 1,700줄짜리 파일에서 전부 그리면 화면이 한참 멎는다.
        whPreviewRows() {
            const f = this.whPreviewFilter;
            if (f === 'all' || f === 'issues') return this.whUpload.preview;
            if (f === 'mismatch') return this.whUpload.preview.filter(p => this.whQtyMismatch(p));
            if (f === 'pending') return this.whUpload.preview.filter(p => !p.반영);
            if (f === 'done') return this.whUpload.preview.filter(p => p.반영);
            return this.whUpload.preview.filter(p => !p.반영 && p.status === f);
        },
        // 待出库: 箱号 = 출고정보.boxLabelId, 托盘号 = 박스 라벨의 palletLabelId(스캔 매핑) → 없으면 출고정보에 남은 값
        outboundRows() {
            return this.outboundList.map(e => this.withBoxPallet(e));
        },
        outboundVisible() {
            return this.outboundOnlyPallet ? this.outboundRows.filter(r => r._pallet) : this.outboundRows;
        },
        // 파렛트별 묶음 — 파렛트 있는 것(번호순) 먼저, 미매핑은 맨 뒤
        outboundGroups() {
            const map = {};
            this.outboundVisible.forEach(r => { (map[r._pallet] = map[r._pallet] || []).push(r); });
            return Object.keys(map).sort((a, b) => (!a) - (!b) || a.localeCompare(b, undefined, { numeric: true })).map(p => {
                const rows = map[p].sort((a, b) => String(a._box || '~').localeCompare(String(b._box || '~'), undefined, { numeric: true }));
                return {
                    pallet: p, rows, info: p ? this.palletInfoMap[p] : null,
                    boxCount: new Set(rows.map(r => r._box).filter(Boolean)).size,
                    qty: rows.reduce((s, r) => s + (parseInt(r.구매요청수량) || 0), 0)
                };
            });
        },
        shippedRows() {
            return this.shippedList.map(e => Object.assign(this.withBoxPallet(e), { _shippedDay: this.fmt(e._shippedDate), _bl: e._blNo || (e.출고정보 && e.출고정보.blNo) || '' }))
                .sort((a, b) => String(b._shippedDay).localeCompare(String(a._shippedDay)));
        },
        todayBoxLabels() { return this.todayLabels.filter(l => l.type === 'box'); },
        todayPalletLabels() { return this.todayLabels.filter(l => l.type === 'pallet'); },
    },
    methods: {
        showSection(kind) {
            return this.section === 'all' || this.section === kind;
        },
        // 待出库列表 탭을 열고 맨 위 待手动匹配 구역으로 스크롤. 탭 번호 = 보이는 탭 기준(stock 탭 3개가 앞에 올 수 있다 + 箱子/托盘标签 1개)
        openManualZone() {
            if (!this.showSection('outbound') || this.tab !== null) return;
            // 처음 열 때는 b-tabs 가 자식 탭을 등록한 뒤에 바꿔야 먹는다(mounted 시점엔 아직 0번으로 되돌린다)
            this.$nextTick(() => {
                this.activeTab = (this.showSection('stock') ? 3 : 0) + 1;
                this.$nextTick(() => {
                    const el = this.$refs.manualZone;
                    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'start' });
                });
            });
        },
        // ── 창고 엑셀 업로드 (출고리스트 / 재고리스트) ─────────────────
        // 출고리스트는 이벤트라 한 번 잘못 나가면 되돌리기 번거롭다 → 매칭 결과를 먼저 보여주고 확정을 받는다.
        // 재고리스트는 스냅샷이라 다음 업로드가 오차를 바로잡는다 → 바로 반영한다.
        whResetUpload(mode, fileName) {
            this.whPreviewFilter = 'pending';   // 새로 올리면 보기 상태도 처음으로 — 남은 행(수동 매칭 대상)부터
            // 업로드id = 서버 멱등키의 재료. 한 번의 업로드 안에서는 같아야 재전송·청크분할이 안전하고,
            // 업로드가 다르면 달라야 같은 파일을 의도적으로 다시 올릴 수 있다.
            const 업로드id = mode + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
            this.whUpload = {
                busy: true, step: '파일 읽는 중...', mode: mode, fileName: fileName, 업로드id: 업로드id, outDate: '',
                total: 0, done: 0, groups: [], issues: [], preview: [], result: null, autoMsg: '',
                extra: { 입고ID: -1, blNo: -1 }
            };
        },
        // 프로젝트 관용대로 FileReader + binary 로 읽는다
        whReadWorkbook(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        // 창고 파일에는 상품 사진이 통째로 박혀 온다(실측 110MB 중 109MB).
                        // 사진까지 펼치면 브라우저가 통째로 멈춘다(실측 69.7초, 실제 화면에선 6분 27초).
                        // 표만 남기고 읽는다 — 못 걷어내면 원본 그대로 가므로 업로드는 안 막힌다.
                        const u8 = new Uint8Array(e.target.result);
                        const slim = stripXlsxMedia(u8);
                        if (slim.dropped) {
                            console.log('창고 엑셀 사진 ' + slim.dropped + '개 제외 — '
                                + (u8.length / 1048576).toFixed(1) + 'MB → '
                                + (slim.out.length / 1048576).toFixed(2) + 'MB');
                        } else if (slim.reason && slim.reason !== '뺄 것 없음') {
                            console.warn('창고 엑셀 사진 제거 건너뜀(' + slim.reason + ') — 원본 그대로 읽습니다');
                        }
                        const wb = XLSX.read(u8ToBinaryString(slim.out), { type: 'binary' });
                        const ws = wb.Sheets[wb.SheetNames[0]];
                        resolve(trimAoa(XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: null })));
                    } catch (err) { reject(err); }
                };
                reader.onerror = () => reject(new Error('파일을 읽지 못했습니다'));
                reader.readAsArrayBuffer(file);
            });
        },
        // 창고 파일의 주문수량과 우리 구매요청수량이 다른가.
        // 대표행에서만 본다(구성품행은 같은 바코드라 중복이다).
        // 주문수량 칸이 비어 있는 파일(0)은 비교하지 않는다 — 없는 걸로 경고를 내면 전부 빨개진다.
        // 창고 주문수량은 1688 에서 산 낱개 수라 묶음(2p·3p) 상품은 구매요청수량 × 판매구성수량과 비교한다
        // (구매요청 50 × 판매구성 2 = 1688 주문 100. 10-06 쿠팡건 파일 불일치 279행 중 267행이 이 경우였다).
        whQtyMismatch(p) {
            if (!p.대표여부 || !p.matched) return false;
            const 창고 = parseInt(p.주문수량) || 0;
            const 우리 = (parseInt(p.matched.구매요청수량) || 0) * this.whCompose(p.matched);
            if (!창고 || !우리) return false;
            return 창고 !== 우리;
        },
        // 후보·매칭 문서의 기준 수량 — 입고된 건은 실제 입고수량, 아니면 구매요청(下单)수량(2026-10-06 YZY). 옛 저장본(기준수량 없음)은 구매요청수량
        whBaseQty(m) {
            if (!m) return 0;
            return m.기준수량 !== undefined ? (parseInt(m.기준수량) || 0) : (parseInt(m.구매요청수량) || 0);
        },
        whQtyLabel(m) {
            if (!m) return '';
            return (parseInt(m.입고수량) || 0) > 0 ? '入库(입고) ' + m.입고수량 + '개' : '下单(구매요청) ' + (parseInt(m.구매요청수량) || 0) + '개';
        },
        whCand(p, id) {
            return (p.candidates || []).find(c => c._id === id) || (p.matched && p.matched._id === id ? p.matched : null);
        },
        // 1688订单号 열 — 매칭(또는 고른 첫) 구매요청의 1688주문번호
        whDoc1688(p) {
            const d = p.matched || this.whCand(p, p.선택_id) || (p.candidates || [])[0];
            return (d && d.주문번호1688) || '';
        },
        whOrderDiff(p) {
            const a = String(p.주문번호 || '').replace(/\s+/g, '');
            const b = String(this.whDoc1688(p)).replace(/\s+/g, '');
            return !!(a && b && a !== b);
        },
        // 확인필요 대표행 다중 선택 — 배정 = [{ _id, 수량 }]. 기본 수량 = 그 건 기준 수량(입고수량)
        whPicked(p, c) {
            return (p.배정 || []).some(a => a._id === c._id);
        },
        whTogglePick(p, c, on) {
            const list = (p.배정 || []).filter(a => a._id !== c._id);
            if (on) list.push({ _id: c._id, 수량: this.whBaseQty(c) });
            p.배정 = list;
            p.선택_id = list.length ? list[0]._id : '';
            p.checked = list.length > 0;
        },
        whPickQty(p, c) {
            const a = (p.배정 || []).find(x => x._id === c._id);
            return a ? a.수량 : '';
        },
        whSetPickQty(p, c, v) {
            const a = (p.배정 || []).find(x => x._id === c._id);
            if (a) a.수량 = Math.max(0, parseInt(v) || 0);
        },
        whPickSum(p) {
            return (p.배정 || []).reduce((s, a) => s + (parseInt(a.수량) || 0), 0);
        },
        // 판매구성수량 — '단품'·빈 값은 1 (서버 매입가 계산과 같은 규칙)
        whCompose(m) {
            const v = m && m.판매구성수량;
            return (v === '단품' || !v) ? 1 : (parseInt(v) || 1);
        },
        // 그룹 → 서버로 보낼 행. 대표행과 구성품행 모두 각각 구매요청 문서이므로 전부 보낸다.
        whGroupsToRows(groups) {
            const rows = [];
            groups.forEach(g => {
                g.행.forEach(r => rows.push({
                    line: r.line, key: g.key, companyid: r.companyid, 바코드: r.바코드,
                    주문번호: r.주문번호, 송장번호: r.송장번호, 옵션: r.옵션, 상품명: r.상품명,
                    대표여부: r === g.대표행,
                    수량: r === g.대표행 ? g.수량 : 0,
                    // 수량 행 여럿을 합친 그룹이면 그 원래 행 번호들(대표행에만)
                    합산행: r === g.대표행 ? (g.합산행 || []) : [],
                    주문수량: r === g.대표행 ? g.주문수량 : 0,
                    // 구성품행도 9번 칸이 채워져 있다 — 같은 주문·같은 규격 문서가 여럿일 때 서버가 수량으로 고르는 데만 쓴다
                    행주문수량: r.주문수량 || 0,
                    박스번호: g.박스번호, 파렛트번호: g.파렛트번호,
                    입고예정일: g.입고예정일, 입고센터: g.입고센터,
                    // 선적(박스) 단위 값이라 대표행에만 싣는다. 열이 없는 파일이면 빈 문자열이다
                    입고ID: r === g.대표행 ? g.입고ID : '',
                    blNo: r === g.대표행 ? g.blNo : '',
                    주문구분: g.주문구분 || '',
                    // 같은 박스 다른 상품에 붙인 합포장 추정행 — 서버가 기타요청사항으로 상대를 확인한다
                    합포장추정: !!r.합포장추정,
                    대표바코드: r.합포장추정 ? g.바코드 : '',
                    대표상품명: r.합포장추정 ? g.상품명 : ''
                }));
            });
            return rows;
        },
        async whMatchRows(rows) {
            const CHUNK = 400;   // 실측 400행 약 2초. 브라우저·서버 양쪽에 무리 없는 크기
            const out = [];
            this.whUpload.total = rows.length;
            for (let i = 0; i < rows.length; i += CHUNK) {
                const part = rows.slice(i, i + CHUNK);
                this.whUpload.step = '매칭 중 ' + Math.min(i + part.length, rows.length) + '/' + rows.length;
                const res = await axios.post('/api/warehouse/matchRows', { rows: part });
                if (res.data.요청결과 !== '성공') throw new Error(res.data.error || '매칭에 실패했습니다');
                res.data.results.forEach(r => out.push(r));
                this.whUpload.done = out.length;
            }
            return out;
        },
        async whApplyItems(url, items) {
            const CHUNK = 200;
            const 요약 = {};
            for (let i = 0; i < items.length; i += CHUNK) {
                const part = items.slice(i, i + CHUNK);
                this.whUpload.step = '반영 중 ' + Math.min(i + part.length, items.length) + '/' + items.length;
                const res = await axios.post(url, { items: part, 업로드id: this.whUpload.업로드id, 파일명: this.whUpload.fileName });
                if (res.data.요청결과 !== '성공') throw new Error(res.data.error || '반영에 실패했습니다');
                Object.keys(res.data.요약 || {}).forEach(k => { 요약[k] = (요약[k] || 0) + res.data.요약[k]; });
            }
            return 요약;
        },
        // 엑셀 → 파싱 → (모드 확인) → 서버로 보낼 행. 두 업로드·출고리스트 저장이 공유하는 앞부분.
        async whParseFile(file, expectMode) {
            const aoa = await this.whReadWorkbook(file);
            const parsed = parseWarehouseList(aoa);
            if (parsed.mode !== expectMode) {
                const 이름 = expectMode === 'export' ? '출고리스트(출고수량)' : '재고리스트(재고수량)';
                throw new Error(parsed.mode
                    ? '이 파일은 ' + (parsed.mode === 'export' ? '출고리스트' : '재고리스트') + '입니다. ' + 이름 + '을 올려주세요'
                    : '창고 양식이 아닙니다. ' + 이름 + '인지 확인해주세요');
            }
            this.whUpload.groups = parsed.groups;
            this.whUpload.issues = parsed.issues;
            this.whUpload.extra = parsed.extra || { 입고ID: -1, blNo: -1 };
            const rows = this.whGroupsToRows(parsed.groups);
            if (rows.length === 0) throw new Error('읽을 수 있는 행이 없습니다');
            return { aoa, rows };
        },
        // 엑셀 → 파싱 → 매칭 → 미리보기 행(재고리스트 업로드)
        async whLoadAndMatch(file, expectMode) {
            const { rows } = await this.whParseFile(file, expectMode);
            const matches = await this.whMatchRows(rows);
            return this.whBuildPreview(rows, matches);
        },
        // 행 + 매칭 결과(matchRows 응답 또는 출고리스트 저장본 행 — 둘 다 line·matched·candidates·reason·합포장근거) → 미리보기 행
        whBuildPreview(rows, matches) {
            const byLine = new Map(matches.map(m => [m.line, m]));
            // 합포장 추정행의 출고수량 = 대표행 수량 × (구성품 구매요청수량 ÷ 대표 구매요청수량). 나눠떨어질 때만
            const headByKey = new Map();
            rows.forEach(r => { if (r.대표여부) headByKey.set(r.key, { 수량: r.수량, m: byLine.get(r.line) || {} }); });
            return rows.map(r => {
                const m = byLine.get(r.line) || {};
                // 배정 = 서버가 후보 여러 건에 나눈 것(수량 합 = 행 수량). 확정으로 본다
                const 자동배정 = !m.matched && Array.isArray(m.배정) && m.배정.length > 0;
                let status = (m.matched || 자동배정) ? 'ok' : ((m.candidates && m.candidates.length) ? 'ambiguous' : 'failed');
                let 합포장수량 = null;
                if (r.합포장추정 && m.matched) {
                    const h = headByKey.get(r.key);
                    const H = h && h.m.matched ? h.m.matched.구매요청수량 : 0;
                    const C = m.matched.구매요청수량;
                    if (H > 0 && C > 0 && (h.수량 * C) % H === 0) 합포장수량 = h.수량 * C / H;
                    if (!m.합포장근거 || m.합포장근거.판정 !== '자동' || 합포장수량 === null) status = 'ambiguous';
                }
                return Object.assign({}, r, {
                    status: status,
                    matched: m.matched || null,
                    candidates: (m.candidates && m.candidates.length) ? m.candidates : (m.matched ? [m.matched] : []),
                    reason: m.reason || '',
                    합포장근거: m.합포장근거 || null,
                    합포장수량: 합포장수량,
                    // 배정 = 이 행을 받을 구매요청과 수량. 확정 1건이면 [그 건, 행 수량], 자동배정이면 서버 값, 확인필요면 화면에서 고른다(여러 건 가능)
                    자동배정: 자동배정,
                    배정: status !== 'ok' ? [] : (자동배정 ? m.배정.map(a => ({ _id: a._id, 수량: a.수량 })) : [{ _id: m.matched._id, 수량: r.수량 }]),
                    선택_id: status === 'ok' ? (자동배정 ? m.배정[0]._id : m.matched._id) : '',
                    checked: status === 'ok' && !r.반영
                });
            });
        },
        // 출고리스트 업로드 — 입구는 둘(待出库 탭 · 生成箱单发票 ②)이지만 같은 길이다(2026-10-07 YZY 「合并到一起」):
        //   저장(서버가 매칭) → 확정 행 자동 출고는 서버 백그라운드 작업(2026-10-07 YZY 「页面取消掉 后台进行」) — 저장 응답에 작업만 받고 화면은 바로 풀린다.
        //   남은 행은 창을 띄우지 않고 「待手动匹配」 페이지에 모인다(같은 날 YZY 「不跳出窗口 在另一个页面单独显示」)
        // 반환 = { fileName, summary, job, jobError }. 같은 날 같은 이름 파일이면 교체(이미 나간 행은 그대로 — 자연키라 두 번 안 나간다)
        async uploadOutboundFile(file, date) {
            this.whResetUpload('export', file.name);
            const { aoa, rows } = await this.whParseFile(file, 'export');
            this.whUpload.step = '保存·匹配中(저장·매칭 중) ' + rows.length + '행...';
            const issues = this.whUpload.issues.map(i => ({ line: i.line, reason: i.reason }));
            const { data } = await this.postJsonGzip('/api/coupassOutboundList/save', { date, fileName: file.name, aoa, rows, issues, extra: this.whUpload.extra, auto: true });
            if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '출고리스트 저장에 실패했습니다');
            this.whUpload.outDate = date;
            return { fileName: data.file.fileName, summary: data.file.summary, job: data.job || null, jobError: data.jobError || '' };
        },
        // 큰 JSON 은 gzip 으로 보낸다(브라우저 CompressionStream → 서버 body-parser 가 Content-Encoding 보고 푼다). 못 쓰는 브라우저·작은 본문은 그대로
        async postJsonGzip(url, body) {
            const json = JSON.stringify(body);
            if (json.length < 256 * 1024 || typeof window.CompressionStream !== 'function') return axios.post(url, body);
            let gz = null;
            try {
                gz = await new Response(new Blob([json]).stream().pipeThrough(new window.CompressionStream('gzip'))).blob();
            } catch (e) {
                console.error('출고리스트 gzip 압축 실패 — 압축 없이 보냅니다', e);
                return axios.post(url, body);
            }
            console.log('출고리스트 요청 ' + (json.length / 1048576).toFixed(2) + 'MB → gzip ' + (gz.size / 1048576).toFixed(2) + 'MB');
            return axios.post(url, gz, { headers: { 'Content-Type': 'application/json', 'Content-Encoding': 'gzip' } });
        },
        outSummaryText(s) {
            if (!s) return '';
            return '自动出库(자동 출고) ' + (s.자동출고 || 0) + '行 · 待手动匹配(수동 매칭 대기) ' + (s.대기 || 0) + '行 · 未匹配(매칭 실패) ' + (s.미매칭 || 0) + '行' +
                (s.수동출고 ? ' · 手动出库(수동 출고) ' + s.수동출고 + '行' : '');
        },
        // 업로드 결과 한 줄 — 자동 출고는 서버가 하고 있다(끝나면 파일 목록 숫자가 바뀐다)
        outUploadText(r) {
            if (r.jobError) return r.fileName + ': ' + r.jobError;
            return r.fileName + ': ' + (r.job ? '已保存，后台自动出库(저장 완료 — 자동 출고는 서버에서 진행)' : '已保存(저장 완료)');
        },
        // 待出库 탭 입구
        async onWhExportFile(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            const date = this.outDate;
            if (this.outFiles.some(f => f.fileName === file.name.trim()) &&
                !confirm(date + ' 已有同名出库清单(' + file.name + ')，要替换吗?(같은 날 같은 이름 파일이 있습니다. 바꿀까요? 이미 출고 반영한 행은 그대로 둡니다)')) {
                if (this.$refs.whExportFile) this.$refs.whExportFile.value = '';
                return;
            }
            try {
                const r = await this.uploadOutboundFile(file, date);
                this.whUpload.busy = false;
                this.afterOutboundUpload(date, [r]);
            } catch (err) {
                console.error('출고리스트 업로드 오류:', err);
                alert(err.message || '출고리스트를 처리하지 못했습니다');
            } finally {
                this.whUpload.busy = false;
                this.whUpload.step = '';
                if (this.$refs.whExportFile) this.$refs.whExportFile.value = '';
            }
        },
        // 업로드 뒤 — 목록 새로고침(작업이 돌면 끝날 때까지 조용히 다시 읽는다), 결과 한 줄 알림. 수동 매칭 창은 띄우지 않는다
        afterOutboundUpload(date, rs) {
            if (date === this.outDate) this.loadOutFiles();
            const bad = rs.some(r => r.jobError);
            this.$bvToast.toast(rs.map(r => this.outUploadText(r)).join(' / '), {
                title: '出库清单已保存(출고리스트 저장)', variant: bad ? 'warning' : 'success', solid: true, autoHideDelay: 6000
            });
        },
        // 生成箱单发票 ② 입구 — InvoiceGenerator 가 부른다(파일 여러 개, 출고일 = 그 화면 날짜). 결과 문구를 돌려준다
        async saveOutboundFromInvoice(files, date) {
            const rs = [];
            try {
                for (const file of files) rs.push(await this.uploadOutboundFile(file, date));
            } finally {
                this.whUpload.busy = false;
                this.whUpload.step = '';
            }
            if (date === this.outDate) this.loadOutFiles();
            return rs.map(r => this.outUploadText(r)).join(' / ');
        },
        outJobRunning(f) {
            return !!(f && f.autoJob && f.autoJob.status === 'running');
        },
        keptReasonText(k) {
            const 거부 = (k && k.거부) || [];
            return 거부.slice(0, 5).map(x => x.line + '行(' + x.reason + ')').join(', ') + (거부.length > 5 ? ' … ' + 거부.length + '行' : '');
        },
        // 중단됨(서버 재시작)·실패한 자동 출고 다시 실행 — 이미 나간 행은 멱등이라 다시 안 나간다
        async rerunAutoJob(f) {
            this.whUpload.busy = true;
            try {
                const { data } = await axios.post('/api/coupassOutboundList/autoStart', { date: f.date, fileName: f.fileName });
                if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '다시 실행 실패');
            } catch (err) {
                console.error('자동 출고 다시 실행 오류:', err);
                alert('重新执行失败(다시 실행 실패): ' + err.message);
            } finally {
                this.whUpload.busy = false;
            }
            this.loadOutFiles();
        },
        // 자동 출고가 도는 파일이 있으면 끝날 때까지 몇 초마다 목록만 다시 읽는다(화면은 막지 않는다)
        scheduleOutJobPoll(files) {
            if (this.outJobTimer) { clearTimeout(this.outJobTimer); this.outJobTimer = null; }
            if (!(files || []).concat(this.pendingFiles).some(f => this.outJobRunning(f))) return;
            this.outJobTimer = setTimeout(() => {
                this.outJobTimer = null;
                this.loadOutFiles(true);
            }, 5000);
        },
        // 돌던 작업이 끝난 파일 — 결과 한 줄 알림 + 재고 숫자 새로고침(한 번만)
        notifyOutJobsDone(prev, files) {
            const was = new Set((prev || []).filter(f => this.outJobRunning(f)).map(f => f._id));
            const done = (files || []).filter(f => was.has(f._id) && !this.outJobRunning(f));
            if (!done.length) return;
            this.search();
            this.$bvToast.toast(done.map(f => f.fileName + ' — ' + (f.autoJob && f.autoJob.status !== 'done' ? '自动出库中断/失败(중단·실패 — 다시 실행 버튼)' : this.outSummaryText(f.summary))).join(' / '), {
                title: '自动出库完成(자동 출고 끝)', variant: done.some(f => f.autoJob && f.autoJob.status !== 'done') ? 'warning' : 'success', solid: true, autoHideDelay: 8000
            });
        },
        // 이번 업로드 자동 출고 취소(파일 목록 버튼) — 다음 단계로 넘어간 행은 서버가 거부하고 목록으로 준다
        async undoAutoBatch(f) {
            if (!f.lastAutoBatch) return;
            if (!confirm('撤销「' + f.fileName + '」本次自动出库?(이번 업로드로 자동 출고된 ' + ((f.summary && f.summary.자동출고) || 0) + '행을 취소합니다 — 재고·선적·상태가 출고 전으로 돌아갑니다)')) return;
            await this.undoOut({ date: f.date, fileName: f.fileName, batch: f.lastAutoBatch });
        },
        // 수동 매칭 창에서 행 하나 출고 취소
        async undoOutRows(lines) {
            if (!confirm('撤销出库(출고 취소) — 行 ' + lines.join(', ') + '?')) return;
            const f = { date: this.whUpload.outDate, fileName: this.whUpload.fileName };
            const msg = this.whUpload.autoMsg;
            await this.undoOut(Object.assign({ lines }, f));
            if (this.showWhPreview) await this.openOutFile(f, msg);
        },
        async undoOut(body) {
            this.whUpload.busy = true;
            try {
                const { data } = await axios.post('/api/coupassOutboundList/undo', body);
                if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '취소 실패');
                let msg = '已撤销(취소함) ' + data.취소 + '行 · 재고 되돌림 ' + (data.이동취소 || 0) + ' · 선적 취소 ' + (data.선적취소 || 0) + ' · 상태 복원 ' + (data.상태복원 || 0);
                if (data.거부 && data.거부.length) {
                    msg += '\n无法撤销(취소 못 함 — 이미 다음 단계) ' + data.거부.length + '行: ' + data.거부.slice(0, 10).map(x => x.line + '行(' + x.reason + ')').join(', ') + (data.거부.length > 10 ? ' …' : '');
                }
                alert(msg);
                this.search();
                this.loadOutFiles();
            } catch (err) {
                console.error('출고 취소 오류:', err);
                alert('撤销失败(취소 실패): ' + err.message);
            } finally {
                this.whUpload.busy = false;
            }
        },
        // 고른 출고일에 저장된 출고리스트 목록(요약만) + 맨 위 待手动匹配 남은 행 파일 목록(같이 읽는다 — 매칭·취소·업로드 뒤 둘 다 바뀐다).
        // quiet = 작업 진행 확인용 재읽기(읽는 중 표시를 안 띄운다)
        async loadOutFiles(quiet) {
            const date = this.outDate;
            if (!date || !this.showSection('outbound')) { this.outFiles = []; return; }
            const pendingP = this.loadPendingFiles(quiet);
            if (!quiet) this.outFilesBusy = true;
            try {
                const { data } = await axios.post('/api/coupassOutboundList/get', { date });
                if (date !== this.outDate) return; // 그새 날짜를 바꿨다
                if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '불러오기 실패');
                const prev = this.outFiles;
                this.outFiles = data.files || [];
                this.notifyOutJobsDone(prev, this.outFiles);
                await pendingP; // 다른 날짜 파일의 자동 출고도 확인 재읽기 대상에 넣으려고
                this.scheduleOutJobPoll(this.outFiles);
            } catch (err) {
                console.error('출고리스트 저장본 불러오기 실패:', err);
                if (!quiet) this.outFiles = [];
            } finally {
                if (date === this.outDate) this.outFilesBusy = false;
            }
        },
        // 待手动匹配 — 최근 60일 남은 행이 있는 파일(자동 출고가 도는·중단된 파일 포함).
        // 작업 끝 알림·작업 확인 재읽기는 날짜 목록(loadOutFiles) 쪽이 맡는다 — 같은 파일이 두 목록에 있어 알림이 두 번 뜨지 않게
        async loadPendingFiles(quiet) {
            if (!quiet) this.pendingBusy = true;
            try {
                const { data } = await axios.post('/api/coupassOutboundList/pending', {});
                if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '불러오기 실패');
                this.pendingFiles = data.files || [];
                this.pendingTotal = data.대기 || 0;
            } catch (err) {
                console.error('수동 매칭 대기 목록 불러오기 실패:', err);
                if (!quiet) { this.pendingFiles = []; this.pendingTotal = 0; }
            } finally {
                this.pendingBusy = false;
            }
        },
        // 저장된 출고리스트 하나 → 확인 창(올릴 때 저장한 매칭 결과로)
        async openOutFile(f, msg) {
            this.whResetUpload('export', f.fileName);
            this.whUpload.autoMsg = msg || '';
            try {
                const { data } = await axios.post('/api/coupassOutboundList/get', { date: f.date, fileName: f.fileName });
                if (data.요청결과 !== '성공' || !data.file) throw new Error((data.error && data.error.errorMessage) || '저장된 출고리스트가 없습니다');
                const file = data.file;
                this.whUpload.outDate = file.date;
                this.whUpload.issues = file.issues || [];
                this.whUpload.extra = file.extra || { 입고ID: -1, blNo: -1 };
                this.whUpload.preview = this.whBuildPreview(file.rows, file.rows);
                this.showWhPreview = true;
            } catch (err) {
                console.error('출고리스트 저장본 열기 실패:', err);
                alert(err.message || '출고리스트를 열지 못했습니다');
            } finally {
                this.whUpload.busy = false;
                this.whUpload.step = '';
            }
        },
        // 저장된 출고리스트 하나 삭제(2026-10-07 YZY 「删除文件」) — 서버가 이 파일로 나간 행(자동·수동)을 먼저 출고 취소하고 지운다.
        //   다음 단계로 넘어간 행이 있으면 파일은 「일부 출고 유지」로 남고 이유가 목록에 보인다.
        //   生成箱单发票 ② 저장본 표도 이 메서드를 그대로 쓴다(InvoiceGenerator deleteOutbound) — 반환 = 확인창에서 진행했으면 true
        async deleteOutFile(f) {
            const n = (f.summary && f.summary.반영) || 0;
            const s = f.summary || {};
            if (!confirm('删除 ' + f.date + ' 出库清单「' + f.fileName + '」?' +
                (n ? '\n已出库 ' + n + '行(自动 ' + (s.자동출고 || 0) + ' · 手动 ' + (s.수동출고 || 0) + ')也会一起撤销出库' : '') +
                '\n(파일을 지웁니다.' + (n ? ' 이 파일로 출고된 ' + n + '행(자동 출고 ' + (s.자동출고 || 0) + '행 포함)도 함께 출고 취소됩니다 — 재고·선적·상태가 출고 전으로 돌아갑니다. 이미 다음 단계로 넘어간 행은 취소되지 않고 파일이 남습니다' : '') + ')')) return false;
            this.whUpload.busy = true;
            try {
                const { data } = await axios.post('/api/coupassOutboundList/delete', { date: f.date, fileName: f.fileName });
                if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '삭제 실패');
                if (data.거부 && data.거부.length) {
                    alert('部分出库保留(일부 출고 유지) — 撤销 ' + (data.취소 || 0) + '行, 无法撤销(취소 못 함 — 이미 다음 단계) ' + data.거부.length + '行: ' +
                        data.거부.slice(0, 10).map(x => x.line + '行(' + x.reason + ')').join(', ') + (data.거부.length > 10 ? ' …' : '') + '\n文件保留(파일은 남겨 둡니다)');
                } else if (data.취소) {
                    this.$bvToast.toast('已删除，撤销出库 ' + data.취소 + '行(삭제 · 출고 취소 ' + data.취소 + '행)', { title: '删除文件(파일 삭제)', variant: 'success', solid: true, autoHideDelay: 6000 });
                }
                if (data.취소) this.search();
            } catch (err) {
                console.error('출고리스트 저장본 삭제 실패:', err);
                alert('删除失败(삭제 실패): ' + err.message);
            } finally {
                this.whUpload.busy = false;
            }
            this.loadOutFiles();
            return true;
        },
        // 모달에서 확정 → 체크된 행만 반영
        // 출고리스트 저장본 기준으로 반영 — 행 내용(화주·바코드·박스·수량·입고ID·BL)은 서버가 저장본에서 읽고,
        // 화면은 고른 구매요청과 나눈 수량만 보낸다(2026-10-06 출고 흐름 통일 §2). 청크는 옛 반영과 같은 200
        async whApplyPicks(picks) {
            const CHUNK = 200;
            const 요약 = {};
            // 수동 확정 1회 = 배치 하나(취소는 줄 번호로 행 단위)
            const batch = 'manual-' + this.whUpload.outDate + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
            for (let i = 0; i < picks.length; i += CHUNK) {
                const part = picks.slice(i, i + CHUNK);
                this.whUpload.step = '반영 중 ' + Math.min(i + part.length, picks.length) + '/' + picks.length;
                const res = await axios.post('/api/warehouse/applyExport', { date: this.whUpload.outDate, fileName: this.whUpload.fileName, picks: part, batch });
                if (res.data.요청결과 !== '성공') throw new Error(res.data.error || '반영에 실패했습니다');
                Object.keys(res.data.요약 || {}).forEach(k => { 요약[k] = (요약[k] || 0) + res.data.요약[k]; });
            }
            return 요약;
        },
        async confirmWhExport() {
            const rows = this.whUpload.preview.filter(p => !p.반영 && p.checked && p.선택_id);
            if (rows.length === 0) { alert('처리할 행이 없습니다'); return; }
            // 여러 건에 나눈 행의 합계가 행 수량과 다르면 한 번 묻는다(그대로도 반영은 된다 — 원장에는 나눈 수량이 기록된다)
            const off = rows.filter(p => p.대표여부 && p.배정 && p.배정.length > 1 && this.whPickSum(p) !== p.수량);
            if (off.length && !confirm('分配数量合计与行数量不同(나눈 수량 합계가 행 수량과 다른 행): ' + off.map(p => p.line + '行 ' + this.whPickSum(p) + '≠' + p.수량).join(', ') + '\n继续吗?(그대로 반영할까요?)')) return;
            const picks = rows.map(p => ({
                line: p.line,
                배정: p.대표여부 && p.배정 && p.배정.length
                    ? p.배정.map(a => ({ _id: a._id, 수량: parseInt(a.수량) || 0 }))
                    : [{ _id: p.선택_id, 수량: p.수량 }],
                합포장수량: p.합포장추정 ? p.합포장수량 : null
            }));
            this.whUpload.busy = true;
            try {
                const 요약 = await this.whApplyPicks(picks);
                this.whUpload.result = 요약;
                this.$bvToast.toast(
                    '출고 ' + ((요약.shipped || 0) + (요약.ledgerOnly || 0)) + '건' +
                    ', 합포장 구성품 ' + (요약.component || 0) + '건' +
                    (요약.duplicated ? ', 이미 반영됨 ' + 요약.duplicated + '건' : '') +
                    (요약.skip ? ', 건너뜀 ' + 요약.skip + '건' : ''),
                    { title: '출고리스트 반영 완료', variant: 'success', solid: true, autoHideDelay: 6000 }
                );
                this.search();
                this.loadOutFiles();
            } catch (err) {
                console.error('출고리스트 반영 오류:', err);
                alert(err.message || '출고리스트를 반영하지 못했습니다');
            } finally {
                this.whUpload.busy = false;
                this.whUpload.step = '';
            }
        },
        // 재고리스트: 매칭된 것을 바로 반영 (스냅샷이라 다음 업로드가 오차를 바로잡는다)
        async onWhStockFile(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            this.whResetUpload('stock', file.name);
            try {
                const preview = await this.whLoadAndMatch(file, 'stock');
                // 매칭이 안 된 행도 원장에는 기록한다 — 재고 수량은 화주·바코드만 있으면 정확해지고,
                // 못 하는 건 진행현황 갱신뿐이다. 그래서 스냅샷을 통째로 보낸다.
                const items = preview.map(p => ({
                    _id: p.선택_id || null, line: p.line, 대표여부: p.대표여부, 수량: p.수량,
                    companyid: p.companyid, 바코드: p.바코드, 상품명: p.상품명,
                    박스번호: p.박스번호, 파렛트번호: p.파렛트번호
                }));
                const 미확정 = preview.filter(p => p.status !== 'ok').length;
                if (items.length === 0) throw new Error('읽을 수 있는 행이 없습니다');
                const 요약 = await this.whApplyItems('/api/warehouse/applyStock', items);
                if (미확정 > 0) 요약.unmatched = 미확정;
                this.whUpload.result = 요약;
                this.$bvToast.toast(
                    '재고 반영 ' + ((요약.stocked || 0) + (요약.ledgerOnly || 0)) + '건' +
                    ', 변동없음 ' + (요약.noChange || 0) + '건' +
                    ', 합포장 구성품 ' + (요약.component || 0) + '건' +
                    (미확정 ? ' · 진행현황은 못 바꾼 행 ' + 미확정 + '건(재고는 반영됨)' : ''),
                    { title: '재고리스트 반영 완료', variant: 'success', solid: true, autoHideDelay: 6000 }
                );
                this.search();
            } catch (err) {
                console.error('재고리스트 업로드 오류:', err);
                alert(err.message || '재고리스트를 처리하지 못했습니다');
            } finally {
                this.whUpload.busy = false;
                this.whUpload.step = '';
                if (this.$refs.whStockFile) this.$refs.whStockFile.value = '';
            }
        },
        getTodaywith() {
            var d = new Date();
            return d.getFullYear() + '-' + ('0'+(1+d.getMonth())).slice(-2) + '-' + ('0'+d.getDate()).slice(-2);
        },
        changedate() {
            var now = new Date();
            this.enddate = this.getTodaywith();
            if (this.selectdate === 'today') { this.startdate = this.getTodaywith(); }
            else if (this.selectdate === 'week') { now.setDate(now.getDate()-7); this.startdate = now.toISOString().slice(0,10); }
            else if (this.selectdate === 'month') { now.setMonth(now.getMonth()-1); this.startdate = now.toISOString().slice(0,10); }
            else if (this.selectdate === '3month') { now.setMonth(now.getMonth()-3); this.startdate = now.toISOString().slice(0,10); }
        },
        fmt(d) {
            if (!d) return '';
            if (typeof d === 'string') return d.slice(0, 10);
            const dt = new Date(d);
            return isNaN(dt.getTime()) ? '' : dt.toISOString().slice(0, 10);
        },
        getReqDate(item) {
            // 서버(slim)가 계산해 준 값 우선. 없으면 processHistory 로 계산(구버전 서버 호환)
            if (item._reqDate !== undefined) return this.fmt(item._reqDate);
            const h = (item.processHistory||[]).find(h => h.toStatus === '출고요청');
            return h ? this.fmt(h.changedAt) : '';
        },
        async search() {
            this.showspinner = true;
            const allStatuses = ['배송완료','입고작업','출고요청','출고대기','중국재고','출고완료','해외입고중','국내입고중','국내창고입고중','국내창고입고완료'];
            try {
                // 재고/출고 현황은 "현재 창고 상태"를 보는 화면이므로 요청일 날짜로 자르지 않는다.
                // (요청일은 입고/출고 시점과 무관하고, 일반요청=숫자(Date.now())/수동입고=ISO문자열로
                //  혼재 저장되어, 요청일 날짜필터 적용 시 최근 출고대기 건이 통째로 누락되던 문제가 있었음)
                // slim: 화면이 쓰는 필드만 받는다. 전체 문서를 받으면 응답이 1.5GB 가 되어
                // (item 필드가 1688 원본을 통째로 들고 있어 문서당 평균 99KB)
                // 내려받다 타임아웃에 걸려 「搜索中发生错误」만 떴다.
                const res = await axios.post('/api/reqpurchase/getstockmanagement', {
                    companyid: this.filterCompanyId || '', status: allStatuses, slim: true
                });
                if (res.data.요청결과 === 'ok') {
                    const arr = res.data.reqpurchase || [];
                    arr.forEach(e => { e.processHistory = e.processHistory || []; });
                    this.allStatusData = arr;
                    this.updateCounts(arr);
                    this.inventoryList = arr;
                    // Phase 5: 출고 처리 + 재고 수정 데이터
                    this.outboundList = arr.filter(e => e.processStatus === '출고대기');
                    this.shippedList = arr.filter(e => e.processStatus === '출고완료');
                    this.selectedOutbound = [];
                    this.outboundBoxMap = {};
                    this.loadBoxPallets();
                    this.auditList = arr.filter(e => ['중국재고', '출고대기', '입고작업'].includes(e.processStatus)).map(e => ({ ...e, 실사수량: null, 실사메모: '' }));
                } else { alert('搜索失败(검색 실패)'); }
            } catch(e) { console.error('검색 오류:', e); alert('搜索中发生错误(검색 중 오류 발생)'); }
            finally { this.showspinner = false; }
        },
        updateCounts(arr) {
            const c = { 배송완료:0, 입고작업:0, 출고요청:0, 출고대기:0, 중국재고:0, 출고완료:0, 해외입고중:0, 국내입고중:0 };
            arr.forEach(e => { if(c[e.processStatus] !== undefined) c[e.processStatus]++; });
            this.sc = c;
        },
        // 입출고이력: 서버가 기간·상태(5종)로 걸러 최신순 최대 1000건을 준다.
        async loadHistory() {
            if (!this.historyStartDate || !this.historyEndDate) return;
            this.historyLoading = true;
            try {
                const res = await axios.post('/api/reqpurchase/getStockHistory', {
                    companyid: this.filterCompanyId || '',
                    startDate: this.historyStartDate, endDate: this.historyEndDate
                });
                if (res.data.요청결과 === 'ok') {
                    this.historyList = (res.data.history || []).map((h, i) => ({ _k: h._id + '|' + i,
                        companyid: h.companyid, 상품명: h.상품명, SKUID: h.SKUID, 바코드: h.바코드,
                        // 주문번호1688·화주주문번호도 행에 둬서 표 Search 로 둘 다 찾게 한다
                        orderNo: h.orderNo || '', 주문번호1688: h.주문번호1688 || '', 화주주문번호: h.화주주문번호 || '',
                        수량: h.구매요청수량, fromStatus: h.changeFrom, toStatus: h.changeType,
                        changedAt: h.changeDate, changedBy: h.changeUser || '', memo: h.changeMemo || '' }));
                } else { alert('查询失败(조회 실패)'); }
            } catch(e) { console.error('입출고이력 조회 오류:', e); alert('查询中发生错误(조회 중 오류 발생)'); }
            finally { this.historyLoading = false; }
        },
        getStatusVariant(status) {
            const map = { 배송완료:'info', 입고작업:'warning', 출고요청:'warning', 출고대기:'primary', 중국재고:'secondary',
                출고완료:'success', 해외입고중:'info', 국내입고중:'primary', 국내창고입고중:'dark', 국내창고입고완료:'success' };
            return map[status] || 'light';
        },
        // 업체 자동완성 목록. 화면에는 안 보이는 datalist 라 무심코 전부 그리기 쉬운데,
        // showimport 업체가 4,239곳이라 datalist 3곳 × 4,239 = option 12,717개가 만들어진다.
        // 그러면 크롬이 힙을 3.9GB 까지 먹고 탭이 통째로 멈춘다(2026-09-10 실측:
        // 화면 로드만으로 20초 뒤 정지, 업로드와 무관). 그래서 입력한 글자에 맞는 것만,
        // 그것도 50개까지만 그린다. 아무것도 안 쳤으면 하나도 그리지 않는다.
        whCidOptions(typed) {
            const q = String(typed == null ? '' : typed).trim().toLowerCase();
            if (!q) return [];
            const out = [];
            for (let i = 0; i < this.companyids.length && out.length < 50; i++) {
                const c = this.companyids[i];
                if (c && String(c).toLowerCase().indexOf(q) !== -1) out.push(c);
            }
            return out;
        },
        async importcompanyids() {
            try {
                const r = await axios.post('/api/getcompanyids', {});
                if (r.data.요청결과 === 'success') {
                    r.data.result.forEach(e => {
                        if (e.auth && e.auth.showimport && !this.companyids.includes(e.companyid)) this.companyids.push(e.companyid);
                    });
                }
            } catch(e) { console.error('companyid 가져오기 실패:', e); }
        },
        // === Phase 5: 수동 입고 ===
        async submitManualInbound() {
            const m = this.manualInbound;
            if (!m.companyid || !m.상품명 || !m.수량 || m.수량 < 1) {
                this.$bvToast.toast('货主、商品名、数量(1以上)为必填项(화주, 상품명, 수량은 필수입니다).', { title: '提示(알림)', variant: 'warning', solid: true });
                return;
            }
            if (!confirm(`确定要登记手动入库吗？(수동 입고를 등록하시겠습니까?)\n货主(화주): ${m.companyid}\n商品名(상품명): ${m.상품명}\n数量(수량): ${m.수량}\n原因(사유): ${m.사유}`)) return;
            this.manualInboundProcessing = true;
            try {
                const res = await axios.post('/api/reqpurchase/createManualInbound', {
                    companyid: m.companyid, 상품명: m.상품명, 바코드: m.바코드,
                    구매요청수량: m.수량, 사유: m.사유, 메모: m.메모
                });
                if (res.data.요청결과 === '성공') {
                    this.$bvToast.toast('手动入库已登记(수동 입고가 등록되었습니다).', { title: '完成(완료)', variant: 'success', solid: true });
                    this.manualInbound = { companyid: '', 상품명: '', 바코드: '', 수량: 1, 사유: '직접입고', 메모: '' };
                    this.search();
                } else { alert('登记失败(등록 실패): ' + (res.data.error || '')); }
            } catch(e) { console.error('수동 입고 오류:', e); alert('手动入库登记中发生错误(수동 입고 등록 중 오류 발생)'); }
            finally { this.manualInboundProcessing = false; }
        },
        // === Phase 5: 출고 처리 ===
        toggleAllOutbound(e) {
            this.selectedOutbound = e.target.checked ? this.outboundVisible.map(i => i._id) : [];
        },
        toggleGroupOutbound(g, on) {
            const ids = g.rows.map(r => r._id);
            const rest = this.selectedOutbound.filter(id => !ids.includes(id));
            this.selectedOutbound = on ? rest.concat(ids) : rest;
        },
        withBoxPallet(e) {
            const out = e.출고정보 || {};
            const boxId = out.boxLabelId || '';
            const b = boxId ? this.boxPalletMap[boxId] : null;
            return Object.assign({}, e, {
                _boxId: boxId,
                _box: boxId.replace(/\n/g, '-'),
                _pallet: (b && b.palletLabelId) || out.palletLabelId || '',
                _boxShip: boxOutboundKey((b && b.shipMethodOverride) || ''), // 옛 저장값 normal_box 도 「红胶带货主地址发货」(YZY 19:33)
                _boxAddr: b && b.customerAddress ? [b.customerAddress.업체명, b.customerAddress.주소, b.customerAddress.연락처].filter(Boolean).join(' / ') : ''
            });
        },
        // 箱号 → 托盘号 — 스캔 매핑은 박스 라벨에만 남으므로(구매요청 문서는 그대로) 읽을 때 붙인다(조회 전용)
        async loadBoxPallets() {
            const ids = [...new Set(this.outboundList.concat(this.shippedList).map(e => e.출고정보 && e.출고정보.boxLabelId).filter(Boolean))];
            if (!ids.length) { this.boxPalletMap = {}; this.palletInfoMap = {}; return; }
            try {
                const { data } = await axios.post('/api/labels/boxPallets', { boxIds: ids });
                if (data.요청결과 !== '성공') { console.error('박스→파렛트 조회 실패:', data.error); return; }
                this.boxPalletMap = data.boxes || {};
                this.palletInfoMap = data.pallets || {};
            } catch (err) {
                console.error('박스→파렛트 조회 오류:', err);
            }
        },
        // 스캔으로 박스가 파렛트에 붙으면 오늘 라벨 + 待出库 묶음을 다시 읽는다
        onPalletMapped() {
            this.loadTodayLabels();
            this.loadBoxPallets();
        },
        getOutboundDate(item) {
            // 서버(slim)가 계산해 준 값 우선. 없으면 processHistory 로 계산(구버전 서버 호환)
            if (item._outboundDate !== undefined) return this.fmt(item._outboundDate);
            const h = (item.processHistory || []).find(h => h.toStatus === '출고대기');
            return h ? this.fmt(h.changedAt) : '';
        },
        async processOutbound() {
            if (!this.selectedOutbound.length) return;
            if (!confirm(`将已选的 ${this.selectedOutbound.length} 件变更为出库完成吗？\n(선택한 ${this.selectedOutbound.length}건을 출고완료로 변경하시겠습니까?)\n(出库待发 → 出库完成)`)) return;
            try {
                // Phase C: 박스/파렛트 출고정보 구성
                const outboundInfo = {};
                for (const id of this.selectedOutbound) {
                    const boxLabelId = this.outboundBoxMap[id] || '';
                    if (boxLabelId) {
                        const boxDoc = this.todayBoxLabels.find(b => b.labelId === boxLabelId);
                        outboundInfo[id] = { boxLabelId, palletLabelId: boxDoc?.palletLabelId || '' };
                    } else {
                        // 이미 박스에 든 건 — 스캔으로 붙은 托盘号를 출고 기록에 남긴다(已出库列表·통관 추적용)
                        const row = this.outboundRows.find(r => r._id === id);
                        if (row && row._boxId && row._pallet) outboundInfo[id] = { boxLabelId: row._boxId, palletLabelId: row._pallet };
                    }
                }
                const res = await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                    ids: this.selectedOutbound, toStatus: '출고완료', memo: '쿠패스 출고 처리 (warehouseManagement)',
                    ...(Object.keys(outboundInfo).length > 0 ? { outboundInfo } : {})
                });
                if (res.data.요청결과 === '성공') {
                    this.$bvToast.toast(`${res.data.successCount}件已变更为出库完成(출고완료로 변경되었습니다).`, { title: '处理完成(처리 완료)', variant: 'success', solid: true });
                    this.search();
                } else { alert('处理失败(처리 실패): ' + JSON.stringify(res.data)); }
            } catch(e) { console.error('출고 처리 오류:', e); alert('出库处理中发生错误(출고 처리 중 오류 발생)'); }
        },
        // === Phase 5: 재고 수정 ===
        async submitAudit() {
            const changed = this.auditList.filter(a => a.실사수량 !== null && a.실사수량 !== a.구매요청수량);
            if (changed.length === 0) {
                this.$bvToast.toast('没有要修改的项目。请输入数量(수정할 항목이 없습니다. 수량을 입력해주세요).', { title: '提示(알림)', variant: 'warning', solid: true });
                return;
            }
            if (!confirm(`确定要修改 ${changed.length} 件的库存数量吗？(${changed.length}건의 재고 수량을 수정하시겠습니까?)`)) return;
            this.auditProcessing = true;
            try {
                const res = await axios.post('/api/reqpurchase/submitStockAudit', {
                    items: changed.map(a => ({ _id: a._id, 실사수량: a.실사수량, 메모: a.실사메모 || '' }))
                });
                if (res.data.요청결과 === '성공') {
                    this.$bvToast.toast(`${res.data.successCount}件库存已修改(재고가 수정되었습니다).`, { title: '修改完成(수정 완료)', variant: 'success', solid: true });
                    this.search();
                } else { alert('库存修改失败(재고 수정 실패): ' + (res.data.error || '')); }
            } catch(e) { console.error('재고 수정 오류:', e); alert('库存修改中发生错误(재고 수정 중 오류 발생)'); }
            finally { this.auditProcessing = false; }
        },
        // ===== 라벨 관리 =====
        // 出库形式 라벨·색 — 한 곳(utils/coupassStatusText). 저장값은 그대로
        outboundTypeText,
        outboundTypeStyle,
        outboundTypeOfBox,
        customsTypeText,
        async loadInitials() {
            // 직원 계정이면 그 계정의 代号(담당자 코드)를 기본값으로 — 브라우저에 남은 값보다 우선. 칸은 그대로 고칠 수 있다.
            // 라벨 이니셜은 2자라서 2자 코드만 채운다. 대표·관리자 계정(코드 없음)은 예전처럼 브라우저 저장값.
            let staffCodeSet = false;
            axios.post('/api/coupass-staff/me', {}).then((res) => {
                const code = res.data && res.data.code;
                if (typeof code === 'string' && /^[A-Z0-9]{2}$/.test(code)) {
                    this.labelForm.담당자이니셜 = code;
                    staffCodeSet = true;
                }
            }).catch((e) => { console.error('담당자 코드 조회 실패:', e); });
            try {
                const req = indexedDB.open('CouplusLabels', 1);
                req.onupgradeneeded = (e) => e.target.result.createObjectStore('settings', { keyPath: 'key' });
                req.onsuccess = (e) => {
                    const db = e.target.result;
                    const tx = db.transaction('settings', 'readonly');
                    const get = tx.objectStore('settings').get('담당자이니셜');
                    get.onsuccess = () => { if (get.result && !staffCodeSet) this.labelForm.담당자이니셜 = get.result.value; };
                };
            } catch(e) { console.warn('IndexedDB load failed:', e); }
        },
        saveInitials() {
            this.labelForm.담당자이니셜 = (this.labelForm.담당자이니셜 || '').toUpperCase();
            try {
                const req = indexedDB.open('CouplusLabels', 1);
                req.onupgradeneeded = (e) => e.target.result.createObjectStore('settings', { keyPath: 'key' });
                req.onsuccess = (e) => {
                    const db = e.target.result;
                    const tx = db.transaction('settings', 'readwrite');
                    tx.objectStore('settings').put({ key: '담당자이니셜', value: this.labelForm.담당자이니셜 });
                };
            } catch(e) { console.warn('IndexedDB save failed:', e); }
        },
        async generateBoxLabels() {
            const f = this.labelForm;
            if (!f.companyid) return alert('请选择货主(화주를 선택해주세요).');
            if (!f.담당자이니셜 || f.담당자이니셜.length !== 2) return alert('请输入2个字的负责人首字母(담당자 이니셜 2자를 입력해주세요).');
            this.labelLoading = true;
            try {
                const res = await axios.post('/api/labels/generateBox', {
                    companyid: f.companyid, 담당자이니셜: f.담당자이니셜,
                    shipmentType: f.boxShipmentType, count: f.boxCount,
                });
                if (res.data.요청결과 === '성공') {
                    this.$bvToast.toast(`箱子标签 ${res.data.labels.length}件生成完成(박스 라벨 생성 완료)`, { title: '标签生成(라벨 생성)', variant: 'success', solid: true });
                    this.loadTodayLabels();
                } else { alert('箱子标签生成失败(박스 라벨 생성 실패)'); }
            } catch(e) { console.error(e); alert('箱子标签生成错误(박스 라벨 생성 오류)'); }
            finally { this.labelLoading = false; }
        },
        async generatePalletLabels() {
            const f = this.labelForm;
            const cid = f.customsType === 'integrated' ? 'RUBY' : f.palletCompanyid;
            if (f.customsType !== 'integrated' && !cid) return alert('请输入公司名(업체명을 입력해주세요).');
            this.labelLoading = true;
            try {
                const res = await axios.post('/api/labels/generatePallet', {
                    companyid: cid, customsType: f.customsType,
                    shipmentType: f.palletShipmentType, count: f.palletCount,
                });
                if (res.data.요청결과 === '성공') {
                    this.$bvToast.toast(`托盘标签 ${res.data.labels.length}件生成完成(파렛트 라벨 생성 완료)`, { title: '标签生成(라벨 생성)', variant: 'success', solid: true });
                    this.loadTodayLabels();
                } else { alert('托盘标签生成失败(파렛트 라벨 생성 실패)'); }
            } catch(e) { console.error(e); alert('托盘标签生成错误(파렛트 라벨 생성 오류)'); }
            finally { this.labelLoading = false; }
        },
        async loadTodayLabels() {
            const d = new Date();
            const dateStr = String(d.getMonth()+1).padStart(2,'0') + String(d.getDate()).padStart(2,'0');
            try {
                const res = await axios.post('/api/labels/list', { type: 'all', date: dateStr });
                this.todayLabels = res.data.labels || [];
            } catch(e) { console.error(e); }
        },
        printLabels(type) {
            this.printLabelList = type === 'box' ? this.todayBoxLabels : this.todayPalletLabels;
            this.$nextTick(() => { this.$htmlToPaper('labelPrintArea'); });
        },
        printSingleLabel(label) {
            this.printLabelList = [label];
            this.$nextTick(() => { this.$htmlToPaper('labelPrintArea'); });
        },
    },
    // 쿠패스 탭(keep-alive) — 다른 탭으로 가면 작업 확인을 멈추고, 돌아오면 다시 읽는다
    activated() {
        if (this._wmActivatedOnce && this.showSection('outbound')) this.loadOutFiles(true);
        this._wmActivatedOnce = true;
    },
    deactivated() {
        if (this.outJobTimer) { clearTimeout(this.outJobTimer); this.outJobTimer = null; }
    },
    beforeDestroy() {
        if (this.outJobTimer) { clearTimeout(this.outJobTimer); this.outJobTimer = null; }
    },
    mounted() {
        this.changedate();
        this.importcompanyids();
        this.loadInitials();
        this.search();   // 화면 진입 시 현재 재고/출고 현황 자동 조회
        this.loadOutFiles(); // 오늘(중국 날짜) 저장된 출고리스트 + 待手动匹配 남은 행
        if (this.$route && this.$route.query.view === 'manual') this.openManualZone(); // 옛 待手动匹配 주소
        // 입출고이력은 기본 최근 30일로 자동 조회
        const s = new Date(); s.setDate(s.getDate() - 30);
        this.historyStartDate = s.getFullYear() + '-' + ('0'+(1+s.getMonth())).slice(-2) + '-' + ('0'+s.getDate()).slice(-2);
        this.historyEndDate = this.getTodaywith();
        this.loadHistory();
    }
}
</script>

